/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten
export const previewCertificate = /* GraphQL */ `mutation PreviewCertificate(
  $organizationID: ID!
  $certificationID: ID!
  $fields: [CertificateFieldInput!]!
  $userData: PreviewUserDataInput
  $courseKey: String
  $programKey: String
) {
  previewCertificate(
    organizationID: $organizationID
    certificationID: $certificationID
    fields: $fields
    userData: $userData
    courseKey: $courseKey
    programKey: $programKey
  ) {
    statusCode
    url
    __typename
  }
}
`;
export const publishToRepository = /* GraphQL */ `mutation PublishToRepository(
  $sourcePath: String!
  $sourceName: String!
  $organizationID: ID!
  $destinationRepository: ID!
  $destinationPath: String
) {
  publishToRepository(
    sourcePath: $sourcePath
    sourceName: $sourceName
    organizationID: $organizationID
    destinationRepository: $destinationRepository
    destinationPath: $destinationPath
  ) {
    id
    organizationID
    createdAt
    updatedAt
    externalID
    repositoryID
    name
    key
    description
    type
    tags
    mimeType
    derivativeStatus
    transcribeStatus
    status
    access
    dominantColor
    length
    transcript
    scormManifest
    useHls
    hlsGenerated
    __typename
  }
}
`;
export const processAsset = /* GraphQL */ `mutation ProcessAsset($organizationID: String!, $assetID: String!) {
  processAsset(organizationID: $organizationID, assetID: $assetID) {
    id
    organizationID
    createdAt
    updatedAt
    externalID
    repositoryID
    name
    key
    description
    type
    tags
    mimeType
    derivativeStatus
    transcribeStatus
    status
    access
    dominantColor
    length
    transcript
    scormManifest
    useHls
    hlsGenerated
    __typename
  }
}
`;
export const processImage = /* GraphQL */ `mutation ProcessImage($organizationID: String!, $assetID: String!) {
  processImage(organizationID: $organizationID, assetID: $assetID) {
    id
    organizationID
    createdAt
    updatedAt
    externalID
    repositoryID
    name
    key
    description
    type
    tags
    mimeType
    derivativeStatus
    transcribeStatus
    status
    access
    dominantColor
    length
    transcript
    scormManifest
    useHls
    hlsGenerated
    __typename
  }
}
`;
export const processVideo = /* GraphQL */ `mutation ProcessVideo($organizationID: String!, $assetID: String!) {
  processVideo(organizationID: $organizationID, assetID: $assetID) {
    id
    organizationID
    createdAt
    updatedAt
    externalID
    repositoryID
    name
    key
    description
    type
    tags
    mimeType
    derivativeStatus
    transcribeStatus
    status
    access
    dominantColor
    length
    transcript
    scormManifest
    useHls
    hlsGenerated
    __typename
  }
}
`;
export const setAccessLevel = /* GraphQL */ `mutation SetAccessLevel(
  $organizationID: String!
  $assetID: String!
  $newLevel: String!
) {
  setAccessLevel(
    organizationID: $organizationID
    assetID: $assetID
    newLevel: $newLevel
  ) {
    id
    organizationID
    createdAt
    updatedAt
    externalID
    repositoryID
    name
    key
    description
    type
    tags
    mimeType
    derivativeStatus
    transcribeStatus
    status
    access
    dominantColor
    length
    transcript
    scormManifest
    useHls
    hlsGenerated
    __typename
  }
}
`;
export const unzip = /* GraphQL */ `mutation Unzip(
  $sourceBucket: String!
  $sourceKey: String!
  $destBucket: String!
  $destKey: String!
) {
  unzip(
    sourceBucket: $sourceBucket
    sourceKey: $sourceKey
    destBucket: $destBucket
    destKey: $destKey
  )
}
`;
export const assistantStartThread = /* GraphQL */ `mutation AssistantStartThread(
  $organizationID: String!
  $itemType: String
  $itemID: String
) {
  assistantStartThread(
    organizationID: $organizationID
    itemType: $itemType
    itemID: $itemID
  )
}
`;
export const assistantPostMessage = /* GraphQL */ `mutation AssistantPostMessage(
  $organizationID: String!
  $itemType: String
  $itemID: String
  $threadID: String
  $content: String
) {
  assistantPostMessage(
    organizationID: $organizationID
    itemType: $itemType
    itemID: $itemID
    threadID: $threadID
    content: $content
  ) {
    organizationID
    id
    itemType
    itemID
    createdAt
    updatedAt
    content
    role
    __typename
  }
}
`;
export const assistantGetMessages = /* GraphQL */ `mutation AssistantGetMessages(
  $organizationID: String!
  $itemType: String
  $itemID: String
  $threadID: String
) {
  assistantGetMessages(
    organizationID: $organizationID
    itemType: $itemType
    itemID: $itemID
    threadID: $threadID
  ) {
    organizationID
    id
    itemType
    itemID
    createdAt
    updatedAt
    content
    role
    __typename
  }
}
`;
export const assistantRunThread = /* GraphQL */ `mutation AssistantRunThread(
  $organizationID: String!
  $itemType: String
  $itemID: String
  $threadID: String
) {
  assistantRunThread(
    organizationID: $organizationID
    itemType: $itemType
    itemID: $itemID
    threadID: $threadID
  ) {
    organizationID
    id
    itemType
    itemID
    threadID
    createdAt
    updatedAt
    status
    messages {
      organizationID
      id
      itemType
      itemID
      createdAt
      updatedAt
      content
      role
      __typename
    }
    __typename
  }
}
`;
export const assistantGetRun = /* GraphQL */ `mutation AssistantGetRun(
  $organizationID: String!
  $itemType: String
  $itemID: String
  $threadID: String
  $runID: String
) {
  assistantGetRun(
    organizationID: $organizationID
    itemType: $itemType
    itemID: $itemID
    threadID: $threadID
    runID: $runID
  ) {
    organizationID
    id
    itemType
    itemID
    threadID
    createdAt
    updatedAt
    status
    messages {
      organizationID
      id
      itemType
      itemID
      createdAt
      updatedAt
      content
      role
      __typename
    }
    __typename
  }
}
`;
export const catalogCategorizeProduct = /* GraphQL */ `mutation CatalogCategorizeProduct(
  $organizationID: String!
  $productID: String!
  $shopifyConfigID: String!
  $optimizeTitle: Boolean
) {
  catalogCategorizeProduct(
    organizationID: $organizationID
    productID: $productID
    shopifyConfigID: $shopifyConfigID
    optimizeTitle: $optimizeTitle
  ) {
    statusCode
    code
    message
    category {
      categoryId
      categoryName
      categoryPath
      confidence
      rationale
      t1Name
      t1Id
      t2Name
      t2Id
      t3Name
      t3Id
      optimizedTitle
      shopifyCategoryGid
      publishable
      publishBlockReason
      __typename
    }
    alternatives {
      categoryId
      categoryName
      categoryPath
      confidence
      rationale
      t1Name
      t1Id
      t2Name
      t2Id
      t3Name
      t3Id
      optimizedTitle
      shopifyCategoryGid
      publishable
      publishBlockReason
      __typename
    }
    lowConfidence
    warnings
    taxonomyAssetID
    sourceProductUpdatedAt
    currentName
    currentShopifyTitle
    __typename
  }
}
`;
export const catalogPublishProductCategorization = /* GraphQL */ `mutation CatalogPublishProductCategorization(
  $organizationID: String!
  $productID: String!
  $shopifyConfigID: String!
  $categoryID: String!
  $categoryName: String
  $categoryPath: String
  $confidence: Float
  $rationale: String
  $optimizedName: String
  $expectedTaxonomyAssetID: ID!
  $expectedProductUpdatedAt: AWSDateTime!
  $expectedShopifyTitle: String
) {
  catalogPublishProductCategorization(
    organizationID: $organizationID
    productID: $productID
    shopifyConfigID: $shopifyConfigID
    categoryID: $categoryID
    categoryName: $categoryName
    categoryPath: $categoryPath
    confidence: $confidence
    rationale: $rationale
    optimizedName: $optimizedName
    expectedTaxonomyAssetID: $expectedTaxonomyAssetID
    expectedProductUpdatedAt: $expectedProductUpdatedAt
    expectedShopifyTitle: $expectedShopifyTitle
  ) {
    statusCode
    code
    message
    published
    shopifyProductGid
    categoryID
    shopifyCategoryGid
    previousName
    publishedName
    productHandle
    warnings
    persisted
    categorization {
      version
      categoryId
      categoryName
      categoryPath
      shopifyCategoryGid
      confidence
      rationale
      taxonomyAssetID
      previousName
      publishedName
      optimizedNameApplied
      publishedAt
      publishedBy
      __typename
    }
    __typename
  }
}
`;
export const generateProductDescriptionOptimization = /* GraphQL */ `mutation GenerateProductDescriptionOptimization(
  $organizationID: String!
  $productID: String!
  $shopifyConfigID: String!
) {
  generateProductDescriptionOptimization(
    organizationID: $organizationID
    productID: $productID
    shopifyConfigID: $shopifyConfigID
  ) {
    statusCode
    code
    message
    proposal {
      structuredPlan
      factRegistry
      renderedHtml
      renderedHtmlHash
      visibleText
      wordCount
      effectiveMaxWords
      wordCountAlgorithmVersion
      sourceProductUpdatedAt
      sourceLocalBodyHash
      factRegistryHash
      policyHash
      promptContractVersion
      modelID
      modelResponseHash
      evidence
      warnings
      __typename
    }
    published
    persisted
    shopifyMutationPerformed
    shopifyProductGid
    product {
      id
      organizationID
      syncConfigID
      handle
      name
      bodyHtml
      vendor
      productType
      imageSrc
      url
      tags
      status
      optionTypes
      productData
      catalogCategorization
      attributes
      productSheet
      externalIDs
      variants
      relatedGuideIds
      createdAt
      updatedAt
      __typename
    }
    warnings
    __typename
  }
}
`;
export const publishProductDescriptionOptimization = /* GraphQL */ `mutation PublishProductDescriptionOptimization(
  $organizationID: String!
  $productID: String!
  $shopifyConfigID: String!
  $proposal: ProductDescriptionOptimizationProposalInput!
) {
  publishProductDescriptionOptimization(
    organizationID: $organizationID
    productID: $productID
    shopifyConfigID: $shopifyConfigID
    proposal: $proposal
  ) {
    statusCode
    code
    message
    proposal {
      structuredPlan
      factRegistry
      renderedHtml
      renderedHtmlHash
      visibleText
      wordCount
      effectiveMaxWords
      wordCountAlgorithmVersion
      sourceProductUpdatedAt
      sourceLocalBodyHash
      factRegistryHash
      policyHash
      promptContractVersion
      modelID
      modelResponseHash
      evidence
      warnings
      __typename
    }
    published
    persisted
    shopifyMutationPerformed
    shopifyProductGid
    product {
      id
      organizationID
      syncConfigID
      handle
      name
      bodyHtml
      vendor
      productType
      imageSrc
      url
      tags
      status
      optionTypes
      productData
      catalogCategorization
      attributes
      productSheet
      externalIDs
      variants
      relatedGuideIds
      createdAt
      updatedAt
      __typename
    }
    warnings
    __typename
  }
}
`;
export const updateOrganizationPaymentCreds = /* GraphQL */ `mutation UpdateOrganizationPaymentCreds(
  $organizationID: String
  $publicKey: String
  $secretKey: String
) {
  updateOrganizationPaymentCreds(
    organizationID: $organizationID
    publicKey: $publicKey
    secretKey: $secretKey
  ) {
    statusCode
    organization {
      id
      name
      createdAt
      updatedAt
      stripePublicKey
      stripeSecretKey
      googleApiConfig
      googleApiSyncInfo
      cognitoUserPoolID
      cognitoWebClientID
      cognitoIdentityPoolID
      signUpFields
      signUpRequiredFields
      appsyncGraphqlID
      appsyncGraphqlKey
      appsyncGraphqlUrl
      deployedAt
      deployStatus
      accessGroups
      enableDiscussionGroups
      enableAI
      defaultRoles
      enableMeetings
      enableHubs
      enableGeo
      clientAILanguageModel
      contentGenerationModel
      clientAIStatus
      crawlConfigs
      internalIpRanges
      usePostHnswFilter
      exportFullConversations
      syncConfigs
      searchGuidance
      status
      deletedAt
      deletedBy
      purgeScheduledAt
      purgeStatus
      purgeSteps
      purgeError
      clonedFromEnv
      clonedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const setCustomerAttributes = /* GraphQL */ `mutation SetCustomerAttributes(
  $organizationID: String
  $customerID: String
  $attributes: [ValueInput]
) {
  setCustomerAttributes(
    organizationID: $organizationID
    customerID: $customerID
    attributes: $attributes
  )
}
`;
export const startCourse = /* GraphQL */ `mutation StartCourse(
  $courseKey: String!
  $organizationID: String!
  $portalID: String!
) {
  startCourse(
    courseKey: $courseKey
    organizationID: $organizationID
    portalID: $portalID
  ) {
    statusCode
    courseProgress {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    documentProgress {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    meetingRegistration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    microcastProgress {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    programProgress {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    programProgresses {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const startDocument = /* GraphQL */ `mutation StartDocument(
  $documentKey: String!
  $organizationID: String!
  $portalID: String!
) {
  startDocument(
    documentKey: $documentKey
    organizationID: $organizationID
    portalID: $portalID
  ) {
    statusCode
    courseProgress {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    documentProgress {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    meetingRegistration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    microcastProgress {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    programProgress {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    programProgresses {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const startMicrocast = /* GraphQL */ `mutation StartMicrocast(
  $microcastKey: String!
  $organizationID: String!
  $portalID: String!
) {
  startMicrocast(
    microcastKey: $microcastKey
    organizationID: $organizationID
    portalID: $portalID
  ) {
    statusCode
    courseProgress {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    documentProgress {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    meetingRegistration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    microcastProgress {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    programProgress {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    programProgresses {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const startProgram = /* GraphQL */ `mutation StartProgram(
  $programKey: String!
  $organizationID: String!
  $portalID: String!
) {
  startProgram(
    programKey: $programKey
    organizationID: $organizationID
    portalID: $portalID
  ) {
    statusCode
    courseProgress {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    documentProgress {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    meetingRegistration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    microcastProgress {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    programProgress {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    programProgresses {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const createPortalMeeting = /* GraphQL */ `mutation CreatePortalMeeting(
  $name: String!
  $startsAt: AWSDateTime
  $libraries: [ID]
  $organizationID: String!
  $portalID: String!
) {
  createPortalMeeting(
    name: $name
    startsAt: $startsAt
    libraries: $libraries
    organizationID: $organizationID
    portalID: $portalID
  ) {
    id
    organizationID
    slug
    libraries
    portalID
    meetingType
    status
    createdAt
    createdByID
    updatedAt
    name
    headline
    description
    content
    instructors
    searchInstructors
    transcript
    image
    recordingID
    recordingMediaPipelineID
    preStartOpenDuration
    startsAt
    postStartGraceDuration
    plannedDuration
    actualDuration
    chimeMeeting {
      ExternalMeetingId
      MediaRegion
      MeetingArn
      MeetingId
      TenantIds
      __typename
    }
    preMeetingMessage
    postMeetingMessage
    mediaRegion
    registrationRequired
    registerBy
    restrictByAccessGroup
    accessGroups
    restrictByCustomer
    customers
    registrationCount
    registrationMax
    portalKicker
    attendees
    __typename
  }
}
`;
export const sendMeetingInvites = /* GraphQL */ `mutation SendMeetingInvites(
  $meetingKey: ID!
  $subject: String
  $message: String
  $emailAddresses: [String]!
  $organizationID: ID!
  $portalID: ID!
) {
  sendMeetingInvites(
    meetingKey: $meetingKey
    subject: $subject
    message: $message
    emailAddresses: $emailAddresses
    organizationID: $organizationID
    portalID: $portalID
  ) {
    statusCode
    message
    __typename
  }
}
`;
export const generateGuide = /* GraphQL */ `mutation GenerateGuide(
  $organizationID: ID!
  $guideId: ID!
  $contentPromptOverride: String
  $additionalInstructions: String
  $optimizationMode: String
  $bylineInstructorID: ID
  $reviewerInstructorID: ID
) {
  generateGuide(
    organizationID: $organizationID
    guideId: $guideId
    contentPromptOverride: $contentPromptOverride
    additionalInstructions: $additionalInstructions
    optimizationMode: $optimizationMode
    bylineInstructorID: $bylineInstructorID
    reviewerInstructorID: $reviewerInstructorID
  ) {
    statusCode
    guideId
    message
    error
    taskId
    __typename
  }
}
`;
export const generateGuideManaged = /* GraphQL */ `mutation GenerateGuideManaged(
  $organizationID: ID!
  $guideId: ID!
  $contentPromptOverride: String
  $additionalInstructions: String
  $optimizationMode: String
) {
  generateGuideManaged(
    organizationID: $organizationID
    guideId: $guideId
    contentPromptOverride: $contentPromptOverride
    additionalInstructions: $additionalInstructions
    optimizationMode: $optimizationMode
  ) {
    statusCode
    guideId
    message
    error
    taskId
    __typename
  }
}
`;
export const scoreGuide = /* GraphQL */ `mutation ScoreGuide(
  $organizationID: ID!
  $guideId: ID!
  $portalID: ID
  $contentFingerprint: String
) {
  scoreGuide(
    organizationID: $organizationID
    guideId: $guideId
    portalID: $portalID
    contentFingerprint: $contentFingerprint
  ) {
    statusCode
    message
    error
    guideId
    overall_score
    scores {
      seo
      geo
      eeat
      ai_extractability
      __typename
    }
    status
    summary
    strengths
    weaknesses
    recommendations
    lastScoredAt
    __typename
  }
}
`;
export const draftGuideRecommendation = /* GraphQL */ `mutation DraftGuideRecommendation(
  $organizationID: ID!
  $guideId: ID!
  $articleHtml: String!
  $recommendation: String!
  $evidence: AWSJSON
  $validationFeedback: String
) {
  draftGuideRecommendation(
    organizationID: $organizationID
    guideId: $guideId
    articleHtml: $articleHtml
    recommendation: $recommendation
    evidence: $evidence
    validationFeedback: $validationFeedback
  ) {
    statusCode
    message
    error
    edits {
      operation
      find
      html
      __typename
    }
    __typename
  }
}
`;
export const suggestGuideCitationDomains = /* GraphQL */ `mutation SuggestGuideCitationDomains(
  $organizationID: ID!
  $portalID: ID!
  $discoveryUrl: String!
  $additionalInstructions: String
  $existingDomains: [String]
) {
  suggestGuideCitationDomains(
    organizationID: $organizationID
    portalID: $portalID
    discoveryUrl: $discoveryUrl
    additionalInstructions: $additionalInstructions
    existingDomains: $existingDomains
  ) {
    statusCode
    jobId
    message
    error
    suggestions {
      domain
      name
      rationale
      __typename
    }
    __typename
  }
}
`;
export const startSuggestGuideCitationDomains = /* GraphQL */ `mutation StartSuggestGuideCitationDomains(
  $organizationID: ID!
  $portalID: ID!
  $discoveryUrl: String!
  $additionalInstructions: String
  $existingDomains: [String]
) {
  startSuggestGuideCitationDomains(
    organizationID: $organizationID
    portalID: $portalID
    discoveryUrl: $discoveryUrl
    additionalInstructions: $additionalInstructions
    existingDomains: $existingDomains
  ) {
    statusCode
    jobId
    message
    error
    suggestions {
      domain
      name
      rationale
      __typename
    }
    __typename
  }
}
`;
export const continueSuggestGuideCitationDomains = /* GraphQL */ `mutation ContinueSuggestGuideCitationDomains(
  $organizationID: ID!
  $jobId: ID!
) {
  continueSuggestGuideCitationDomains(
    organizationID: $organizationID
    jobId: $jobId
  ) {
    statusCode
    jobId
    message
    error
    suggestions {
      domain
      name
      rationale
      __typename
    }
    __typename
  }
}
`;
export const generateCoreGuide = /* GraphQL */ `mutation GenerateCoreGuide(
  $organizationID: ID!
  $clusterID: ID!
  $sourceUrl: String
  $contentPromptOverride: String
  $additionalInstructions: String
  $optimizationMode: String
  $bylineInstructorID: ID
  $reviewerInstructorID: ID
) {
  generateCoreGuide(
    organizationID: $organizationID
    clusterID: $clusterID
    sourceUrl: $sourceUrl
    contentPromptOverride: $contentPromptOverride
    additionalInstructions: $additionalInstructions
    optimizationMode: $optimizationMode
    bylineInstructorID: $bylineInstructorID
    reviewerInstructorID: $reviewerInstructorID
  ) {
    statusCode
    guideId
    clusterId
    message
    error
    __typename
  }
}
`;
export const generateCoreGuideManaged = /* GraphQL */ `mutation GenerateCoreGuideManaged(
  $organizationID: ID!
  $clusterID: ID!
  $sourceUrl: String
  $contentPromptOverride: String
  $additionalInstructions: String
  $optimizationMode: String
) {
  generateCoreGuideManaged(
    organizationID: $organizationID
    clusterID: $clusterID
    sourceUrl: $sourceUrl
    contentPromptOverride: $contentPromptOverride
    additionalInstructions: $additionalInstructions
    optimizationMode: $optimizationMode
  ) {
    statusCode
    guideId
    clusterId
    message
    error
    __typename
  }
}
`;
export const acceptGuideDraft = /* GraphQL */ `mutation AcceptGuideDraft($organizationID: ID!, $guideId: ID!, $taskId: ID!) {
  acceptGuideDraft(
    organizationID: $organizationID
    guideId: $guideId
    taskId: $taskId
  )
}
`;
export const rejectGuideDraft = /* GraphQL */ `mutation RejectGuideDraft($organizationID: ID!, $guideId: ID!, $taskId: ID!) {
  rejectGuideDraft(
    organizationID: $organizationID
    guideId: $guideId
    taskId: $taskId
  )
}
`;
export const dismissImageReview = /* GraphQL */ `mutation DismissImageReview($organizationID: ID!, $guideId: ID!, $taskId: ID!) {
  dismissImageReview(
    organizationID: $organizationID
    guideId: $guideId
    taskId: $taskId
  )
}
`;
export const generateGuidesFromUrl = /* GraphQL */ `mutation GenerateGuidesFromUrl(
  $organizationID: ID!
  $portalID: ID
  $syncConfigID: ID
  $url: String!
  $topicsPromptOverride: String
  $contentPromptOverride: String
  $additionalInstructions: String
) {
  generateGuidesFromUrl(
    organizationID: $organizationID
    portalID: $portalID
    syncConfigID: $syncConfigID
    url: $url
    topicsPromptOverride: $topicsPromptOverride
    contentPromptOverride: $contentPromptOverride
    additionalInstructions: $additionalInstructions
  ) {
    statusCode
    guides {
      id
      organizationID
      portalID
      syncConfigID
      guideClusterID
      guideType
      role
      targetPrompts
      intentDescription
      title
      slug
      excerpt
      keywords
      relatedGuideIds
      bylineInstructorID
      reviewerInstructorID
      metaTitle
      metaDescription
      guideImageAssetID
      guideImageUrl
      guideImageAltText
      guideImageSource
      guideImagePrompt
      content
      status
      sourceUrl
      topic
      generationStatus
      generationErrorMessage
      generationFailureId
      generationFailurePhase
      publishStatus
      publishGateStatus
      shopifyBlogId
      shopifyBlogHandle
      shopifyArticleId
      shopifyArticleHandle
      shopifyArticleUrl
      shopifyArticleTemplateSuffix
      lastPublishAttemptAt
      lastPublishOperation
      lastPublishErrorMessage
      shopifyUrlSource
      publishVerificationStatus
      lastPublishResponse
      publishedAt
      lastGeneratedAt
      lastPublishedAt
      suggestedProductHandles
      approvalStatus
      approvalNote
      generationSource
      syncStatus
      lastSyncedAt
      createdAt
      updatedAt
      publishedVersionId
      currentDraftVersionId
      currentChangeSetId
      livePublishedAt
      deletedAt
      guideScore
      guideScoreBreakdown
      lastScoredAt
      guideScoreFingerprint
      __typename
    }
    siteSummary
    topics
    message
    error
    taskId
    __typename
  }
}
`;
export const planGuideDiscoveryFromUrl = /* GraphQL */ `mutation PlanGuideDiscoveryFromUrl(
  $organizationID: ID!
  $portalID: ID
  $url: String!
  $strategyLevel: String
  $additionalInstructions: String
) {
  planGuideDiscoveryFromUrl(
    organizationID: $organizationID
    portalID: $portalID
    url: $url
    strategyLevel: $strategyLevel
    additionalInstructions: $additionalInstructions
  ) {
    statusCode
    executiveSummary
    baselineSummary
    parentJobId
    refinementRound
    clusters {
      name
      description
      guidesNeeded
      rationale
      __typename
    }
    message
    error
    jobId
    taskId
    __typename
  }
}
`;
export const startPlanGuideDiscoveryFromUrl = /* GraphQL */ `mutation StartPlanGuideDiscoveryFromUrl(
  $organizationID: ID!
  $portalID: ID
  $url: String!
  $strategyLevel: String
  $additionalInstructions: String
  $previousJobId: ID
  $refinementNotes: String
) {
  startPlanGuideDiscoveryFromUrl(
    organizationID: $organizationID
    portalID: $portalID
    url: $url
    strategyLevel: $strategyLevel
    additionalInstructions: $additionalInstructions
    previousJobId: $previousJobId
    refinementNotes: $refinementNotes
  ) {
    statusCode
    executiveSummary
    baselineSummary
    parentJobId
    refinementRound
    clusters {
      name
      description
      guidesNeeded
      rationale
      __typename
    }
    message
    error
    jobId
    taskId
    __typename
  }
}
`;
export const continuePlanGuideDiscoveryFromUrl = /* GraphQL */ `mutation ContinuePlanGuideDiscoveryFromUrl($organizationID: ID!, $jobId: ID!) {
  continuePlanGuideDiscoveryFromUrl(
    organizationID: $organizationID
    jobId: $jobId
  ) {
    statusCode
    executiveSummary
    baselineSummary
    parentJobId
    refinementRound
    clusters {
      name
      description
      guidesNeeded
      rationale
      __typename
    }
    message
    error
    jobId
    taskId
    __typename
  }
}
`;
export const startGenerateLlmsTxt = /* GraphQL */ `mutation StartGenerateLlmsTxt(
  $organizationID: ID!
  $portalID: ID
  $siteUrl: String!
  $companyName: String
  $description: String
  $context: String
) {
  startGenerateLlmsTxt(
    organizationID: $organizationID
    portalID: $portalID
    siteUrl: $siteUrl
    companyName: $companyName
    description: $description
    context: $context
  ) {
    statusCode
    jobId
    message
    text
    links
    warnings
    error
    __typename
  }
}
`;
export const continueGenerateLlmsTxt = /* GraphQL */ `mutation ContinueGenerateLlmsTxt($organizationID: ID!, $jobId: ID!) {
  continueGenerateLlmsTxt(organizationID: $organizationID, jobId: $jobId) {
    statusCode
    jobId
    message
    text
    links
    warnings
    error
    __typename
  }
}
`;
export const regenerateGuideTopic = /* GraphQL */ `mutation RegenerateGuideTopic(
  $organizationID: ID!
  $guideId: ID!
  $topicsPromptOverride: String
) {
  regenerateGuideTopic(
    organizationID: $organizationID
    guideId: $guideId
    topicsPromptOverride: $topicsPromptOverride
  ) {
    statusCode
    guideId
    topic
    message
    error
    taskId
    __typename
  }
}
`;
export const publishGuide = /* GraphQL */ `mutation PublishGuide($organizationID: ID!, $guideId: ID!) {
  publishGuide(organizationID: $organizationID, guideId: $guideId) {
    statusCode
    guideId
    shopifyArticleId
    shopifyArticleUrl
    message
    error
    taskId
    __typename
  }
}
`;
export const unpublishGuide = /* GraphQL */ `mutation UnpublishGuide($organizationID: ID!, $guideId: ID!) {
  unpublishGuide(organizationID: $organizationID, guideId: $guideId) {
    statusCode
    guideId
    shopifyArticleId
    shopifyArticleUrl
    unpublished
    alreadyUnpublished
    message
    error
    __typename
  }
}
`;
export const deleteGuideCascade = /* GraphQL */ `mutation DeleteGuideCascade($organizationID: ID!, $guideId: ID!) {
  deleteGuideCascade(organizationID: $organizationID, guideId: $guideId) {
    statusCode
    guideId
    deleted
    articleDeleted
    alreadyDeleted
    productReferenceUpdates
    guideReferenceUpdates
    unresolvedProductHandles
    message
    error
    __typename
  }
}
`;
export const rebuildGuideBlogIndex = /* GraphQL */ `mutation RebuildGuideBlogIndex($organizationID: ID!, $syncConfigID: ID!) {
  rebuildGuideBlogIndex(
    organizationID: $organizationID
    syncConfigID: $syncConfigID
  ) {
    statusCode
    updated
    handles
    handleCount
    message
    error
    __typename
  }
}
`;
export const deleteGuideClusterCascade = /* GraphQL */ `mutation DeleteGuideClusterCascade(
  $organizationID: ID!
  $clusterId: ID!
  $targetClusterId: ID
) {
  deleteGuideClusterCascade(
    organizationID: $organizationID
    clusterId: $clusterId
    targetClusterId: $targetClusterId
  ) {
    statusCode
    clusterId
    targetClusterId
    impactCount
    reassignedCount
    deletedCount
    unpublishedCount
    coreDeletedCount
    productReferenceUpdates
    guideReferenceUpdates
    unresolvedProductHandles
    clusterDeleted
    blockedGuideIds
    failures {
      guideId
      title
      operation
      error
      __typename
    }
    message
    error
    __typename
  }
}
`;
export const publishInstructorBio = /* GraphQL */ `mutation PublishInstructorBio(
  $organizationID: ID!
  $instructorID: ID!
  $syncConfigID: ID
) {
  publishInstructorBio(
    organizationID: $organizationID
    instructorID: $instructorID
    syncConfigID: $syncConfigID
  ) {
    statusCode
    instructorID
    shopifyArticleId
    shopifyArticleUrl
    message
    error
    __typename
  }
}
`;
export const listGuideShopifyArticleTemplates = /* GraphQL */ `mutation ListGuideShopifyArticleTemplates(
  $organizationID: ID!
  $syncConfigID: ID
) {
  listGuideShopifyArticleTemplates(
    organizationID: $organizationID
    syncConfigID: $syncConfigID
  ) {
    statusCode
    templates {
      label
      suffix
      isDefault
      __typename
    }
    message
    error
    __typename
  }
}
`;
export const auditShopifySitemap = /* GraphQL */ `mutation AuditShopifySitemap(
  $organizationID: ID!
  $syncConfigID: ID
  $siteUrl: String
  $validateSampleSize: Int
  $maxSitemaps: Int
) {
  auditShopifySitemap(
    organizationID: $organizationID
    syncConfigID: $syncConfigID
    siteUrl: $siteUrl
    validateSampleSize: $validateSampleSize
    maxSitemaps: $maxSitemaps
  ) {
    statusCode
    message
    error
    rootSitemapUrl
    shop
    checkedAt
    summary
    issues
    recommendations
    audit
    __typename
  }
}
`;
export const generateShopifyGeoSitemap = /* GraphQL */ `mutation GenerateShopifyGeoSitemap(
  $organizationID: ID!
  $syncConfigID: ID
  $siteUrl: String
) {
  generateShopifyGeoSitemap(
    organizationID: $organizationID
    syncConfigID: $syncConfigID
    siteUrl: $siteUrl
  ) {
    statusCode
    message
    error
    shop
    filename
    xml
    urlCount
    guideUrlCount
    instructorBioUrlCount
    __typename
  }
}
`;
export const applyShopifyGeoSitemapAsset = /* GraphQL */ `mutation ApplyShopifyGeoSitemapAsset(
  $organizationID: ID!
  $syncConfigID: ID
  $siteUrl: String
) {
  applyShopifyGeoSitemapAsset(
    organizationID: $organizationID
    syncConfigID: $syncConfigID
    siteUrl: $siteUrl
  ) {
    statusCode
    message
    error
    shop
    filename
    xml
    urlCount
    guideUrlCount
    instructorBioUrlCount
    __typename
  }
}
`;
export const auditShopifyRobots = /* GraphQL */ `mutation AuditShopifyRobots(
  $organizationID: ID!
  $syncConfigID: ID
  $siteUrl: String
) {
  auditShopifyRobots(
    organizationID: $organizationID
    syncConfigID: $syncConfigID
    siteUrl: $siteUrl
  ) {
    statusCode
    message
    error
    robotsUrl
    shop
    checkedAt
    currentPublicRobotsTxt
    crawlable
    hasSitemapReference
    hasNativeSitemapReference
    hasCustomRobotsTxt
    currentRobotsLiquid
    proposedTemplate
    sitemapUrls
    checkedUserAgents
    checkedPaths
    issues
    recommendations
    __typename
  }
}
`;
export const applyShopifyRobotsTemplate = /* GraphQL */ `mutation ApplyShopifyRobotsTemplate(
  $organizationID: ID!
  $syncConfigID: ID
  $siteUrl: String
) {
  applyShopifyRobotsTemplate(
    organizationID: $organizationID
    syncConfigID: $syncConfigID
    siteUrl: $siteUrl
  ) {
    statusCode
    message
    error
    shop
    appliedFilename
    appliedTemplate
    __typename
  }
}
`;
export const associateGuideProducts = /* GraphQL */ `mutation AssociateGuideProducts(
  $organizationID: ID!
  $guideId: ID!
  $mode: GuideProductAssociationMode!
  $handles: [String!]
  $limit: Int
  $previewOnly: Boolean
  $generationErrorRecovery: AWSJSON
) {
  associateGuideProducts(
    organizationID: $organizationID
    guideId: $guideId
    mode: $mode
    handles: $handles
    limit: $limit
    previewOnly: $previewOnly
    generationErrorRecovery: $generationErrorRecovery
  ) {
    statusCode
    guideId
    handles
    matchedCount
    mode
    message
    error
    generationErrorResolution
    updatedAt
    taskId
    __typename
  }
}
`;
export const generateRelatedGuides = /* GraphQL */ `mutation GenerateRelatedGuides(
  $organizationID: ID!
  $guideId: ID!
  $limit: Int
) {
  generateRelatedGuides(
    organizationID: $organizationID
    guideId: $guideId
    limit: $limit
  ) {
    statusCode
    guideId
    guideClusterID
    updatedGuideCount
    message
    error
    taskId
    __typename
  }
}
`;
export const generateRelatedGuidesForCluster = /* GraphQL */ `mutation GenerateRelatedGuidesForCluster(
  $organizationID: ID!
  $guideClusterID: ID!
  $limitPerGuide: Int
) {
  generateRelatedGuidesForCluster(
    organizationID: $organizationID
    guideClusterID: $guideClusterID
    limitPerGuide: $limitPerGuide
  ) {
    statusCode
    guideId
    guideClusterID
    updatedGuideCount
    message
    error
    taskId
    __typename
  }
}
`;
export const embedRelatedGuideLinks = /* GraphQL */ `mutation EmbedRelatedGuideLinks(
  $organizationID: ID!
  $guideId: ID!
  $mode: String
) {
  embedRelatedGuideLinks(
    organizationID: $organizationID
    guideId: $guideId
    mode: $mode
  ) {
    statusCode
    guideId
    embeddedCount
    predictedCount
    message
    error
    __typename
  }
}
`;
export const embedRelatedGuideLinksManaged = /* GraphQL */ `mutation EmbedRelatedGuideLinksManaged(
  $organizationID: ID!
  $guideId: ID!
  $mode: String
) {
  embedRelatedGuideLinksManaged(
    organizationID: $organizationID
    guideId: $guideId
    mode: $mode
  ) {
    statusCode
    guideId
    embeddedCount
    predictedCount
    message
    error
    __typename
  }
}
`;
export const auditGuideClusterLinks = /* GraphQL */ `mutation AuditGuideClusterLinks(
  $organizationID: ID!
  $guideClusterID: ID!
  $auditMode: String
  $graceWindowActive: Boolean
) {
  auditGuideClusterLinks(
    organizationID: $organizationID
    guideClusterID: $guideClusterID
    auditMode: $auditMode
    graceWindowActive: $graceWindowActive
  ) {
    statusCode
    guideClusterID
    auditMode
    status
    articlesChecked
    internalGuideLinks
    brokenInternalGuideLinks
    wrongBlogHandleLinks
    unpublishedTargetLinks
    warnings
    summaryJson
    edgesJson
    suggestedActions
    message
    error
    __typename
  }
}
`;
export const generateGuideImage = /* GraphQL */ `mutation GenerateGuideImage(
  $organizationID: ID!
  $guideId: ID!
  $prompt: String
) {
  generateGuideImage(
    organizationID: $organizationID
    guideId: $guideId
    prompt: $prompt
  ) {
    statusCode
    guideId
    imageUrl
    prompt
    message
    error
    assetId
    taskId
    __typename
  }
}
`;
export const generateImageAltText = /* GraphQL */ `mutation GenerateImageAltText(
  $organizationID: ID!
  $guideId: ID
  $imageUrl: String!
) {
  generateImageAltText(
    organizationID: $organizationID
    guideId: $guideId
    imageUrl: $imageUrl
  ) {
    statusCode
    altText
    message
    error
    __typename
  }
}
`;
export const refineGuideImagePreview = /* GraphQL */ `mutation RefineGuideImagePreview(
  $organizationID: ID!
  $guideId: ID!
  $refinementPrompt: String
  $previousImageUrl: String!
  $basePrompt: String
) {
  refineGuideImagePreview(
    organizationID: $organizationID
    guideId: $guideId
    refinementPrompt: $refinementPrompt
    previousImageUrl: $previousImageUrl
    basePrompt: $basePrompt
  ) {
    statusCode
    guideId
    imageUrl
    prompt
    message
    error
    assetId
    taskId
    __typename
  }
}
`;
export const prepareGuideImageUpload = /* GraphQL */ `mutation PrepareGuideImageUpload(
  $organizationID: ID!
  $portalID: ID
  $mimeType: String!
  $fileName: String
) {
  prepareGuideImageUpload(
    organizationID: $organizationID
    portalID: $portalID
    mimeType: $mimeType
    fileName: $fileName
  ) {
    statusCode
    assetId
    uploadUrl
    durableUrl
    mimeType
    error
    __typename
  }
}
`;
export const finalizeGuideImageUpload = /* GraphQL */ `mutation FinalizeGuideImageUpload($organizationID: ID!, $assetId: ID!) {
  finalizeGuideImageUpload(organizationID: $organizationID, assetId: $assetId) {
    statusCode
    assetId
    url
    mimeType
    error
    __typename
  }
}
`;
export const trackCourseItemProgress = /* GraphQL */ `mutation TrackCourseItemProgress(
  $courseKey: String
  $courseItemID: String
  $progress: String
  $lastPosition: Int
  $maxPosition: Int
  $organizationID: String
) {
  trackCourseItemProgress(
    courseKey: $courseKey
    courseItemID: $courseItemID
    progress: $progress
    lastPosition: $lastPosition
    maxPosition: $maxPosition
    organizationID: $organizationID
  ) {
    statusCode
    courseProgress {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    documentProgress {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    meetingRegistration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    microcastProgress {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    programProgress {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    programProgresses {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const scormCommit = /* GraphQL */ `mutation ScormCommit($commitData: ScormCommitInput!, $organizationID: String!) {
  scormCommit(commitData: $commitData, organizationID: $organizationID) {
    statusCode
    message
    courseProgress {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    microcastProgress {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    programProgresses {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    __typename
  }
}
`;
export const trackDocumentProgress = /* GraphQL */ `mutation TrackDocumentProgress(
  $documentKey: String
  $organizationID: String
  $progress: String
) {
  trackDocumentProgress(
    documentKey: $documentKey
    organizationID: $organizationID
    progress: $progress
  ) {
    statusCode
    courseProgress {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    documentProgress {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    meetingRegistration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    microcastProgress {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    programProgress {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    programProgresses {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const updateQuizResults = /* GraphQL */ `mutation UpdateQuizResults(
  $id: String
  $modelName: String
  $quizResults: String
) {
  updateQuizResults(id: $id, modelName: $modelName, quizResults: $quizResults) {
    statusCode
    courseProgress {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    documentProgress {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    meetingRegistration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    microcastProgress {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    programProgress {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    programProgresses {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const trackProgramProgress = /* GraphQL */ `mutation TrackProgramProgress(
  $programKey: String
  $programItemID: String
  $organizationID: String
  $progress: String
) {
  trackProgramProgress(
    programKey: $programKey
    programItemID: $programItemID
    organizationID: $organizationID
    progress: $progress
  ) {
    statusCode
    courseProgress {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    documentProgress {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    meetingRegistration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    microcastProgress {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    programProgress {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    programProgresses {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const trackMicrocastProgress = /* GraphQL */ `mutation TrackMicrocastProgress(
  $microcastKey: String
  $organizationID: String
  $progress: String
  $lastPosition: Int
  $maxPosition: Int
) {
  trackMicrocastProgress(
    microcastKey: $microcastKey
    organizationID: $organizationID
    progress: $progress
    lastPosition: $lastPosition
    maxPosition: $maxPosition
  ) {
    statusCode
    courseProgress {
      id
      organizationID
      customerID
      courseID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      lessonProgress
      lessonsCompleted
      quizResults
      notes
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      scormData
      tracking
      __typename
    }
    documentProgress {
      id
      organizationID
      customerID
      documentKey
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      status
      viewCount
      history
      includeInMyDocuments
      __typename
    }
    meetingRegistration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    microcastProgress {
      id
      organizationID
      customerID
      microcastID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      notes
      scormData
      lastPosition
      maxPosition
      tracking
      __typename
    }
    programProgress {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    programProgresses {
      id
      organizationID
      customerID
      programID
      createdAt
      updatedAt
      progress
      startedDate
      completeDate
      lastActiveDate
      expiryDate
      sectionProgress
      lessonsCompleted
      quizResults
      notes
      courseItems
      hasCertification
      certificateAwarded
      certificates
      certifications
      completedCertifications
      certificateStatus
      certificateScore
      certificateAwardedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const executeEngagementFlow = /* GraphQL */ `mutation ExecuteEngagementFlow(
  $customerID: String
  $flowID: String
  $organizationID: String
) {
  executeEngagementFlow(
    customerID: $customerID
    flowID: $flowID
    organizationID: $organizationID
  ) {
    statusCode
    body
    __typename
  }
}
`;
export const enrollCustomers = /* GraphQL */ `mutation EnrollCustomers(
  $itemType: String
  $itemKey: ID
  $customerIDs: [ID]
  $organizationID: ID
  $portalID: ID
) {
  enrollCustomers(
    itemType: $itemType
    itemKey: $itemKey
    customerIDs: $customerIDs
    organizationID: $organizationID
    portalID: $portalID
  )
}
`;
export const startCheckout = /* GraphQL */ `mutation StartCheckout(
  $organizationID: String
  $portalID: String
  $returnUrl: String
  $cancelUrl: String
  $items: [CheckoutItemInput]
) {
  startCheckout(
    organizationID: $organizationID
    portalID: $portalID
    returnUrl: $returnUrl
    cancelUrl: $cancelUrl
    items: $items
  ) {
    statusCode
    member {
      id
      organizationID
      customerID
      portalID
      membershipID
      name
      status
      createdAt
      updatedAt
      expiresOn
      lastPaymentAt
      nextPaymentAt
      failedPaymentAttempts
      stripeSessionID
      stripePaymentIntentID
      stripeSubscriptionID
      stripeCustomerID
      stripeInvoiceID
      stripeExpiresAt
      __typename
    }
    checkoutUrl
    message
    richText
    __typename
  }
}
`;
export const verifyCheckout = /* GraphQL */ `mutation VerifyCheckout(
  $organizationID: String
  $portalID: String
  $memberID: String
) {
  verifyCheckout(
    organizationID: $organizationID
    portalID: $portalID
    memberID: $memberID
  ) {
    statusCode
    member {
      id
      organizationID
      customerID
      portalID
      membershipID
      name
      status
      createdAt
      updatedAt
      expiresOn
      lastPaymentAt
      nextPaymentAt
      failedPaymentAttempts
      stripeSessionID
      stripePaymentIntentID
      stripeSubscriptionID
      stripeCustomerID
      stripeInvoiceID
      stripeExpiresAt
      __typename
    }
    success
    message
    __typename
  }
}
`;
export const swapMembership = /* GraphQL */ `mutation SwapMembership(
  $organizationID: String
  $portalID: String
  $existingMemberID: String
  $newMembershipID: String
) {
  swapMembership(
    organizationID: $organizationID
    portalID: $portalID
    existingMemberID: $existingMemberID
    newMembershipID: $newMembershipID
  ) {
    statusCode
    expiredMember {
      id
      organizationID
      customerID
      portalID
      membershipID
      name
      status
      createdAt
      updatedAt
      expiresOn
      lastPaymentAt
      nextPaymentAt
      failedPaymentAttempts
      stripeSessionID
      stripePaymentIntentID
      stripeSubscriptionID
      stripeCustomerID
      stripeInvoiceID
      stripeExpiresAt
      __typename
    }
    newMember {
      id
      organizationID
      customerID
      portalID
      membershipID
      name
      status
      createdAt
      updatedAt
      expiresOn
      lastPaymentAt
      nextPaymentAt
      failedPaymentAttempts
      stripeSessionID
      stripePaymentIntentID
      stripeSubscriptionID
      stripeCustomerID
      stripeInvoiceID
      stripeExpiresAt
      __typename
    }
    success
    message
    __typename
  }
}
`;
export const syncOrganizationToCognito = /* GraphQL */ `mutation SyncOrganizationToCognito($organizationID: String) {
  syncOrganizationToCognito(organizationID: $organizationID)
}
`;
export const createCognitoCustomer = /* GraphQL */ `mutation CreateCognitoCustomer(
  $organizationID: String
  $email: String
  $emailVerified: Boolean
  $temporaryPassword: String
) {
  createCognitoCustomer(
    organizationID: $organizationID
    email: $email
    emailVerified: $emailVerified
    temporaryPassword: $temporaryPassword
  ) {
    statusCode
    cognitoCustomer {
      Username
      UserCreateDate
      UserLastModifiedDate
      Enabled
      UserStatus
      PreferredMfaSetting
      UserMFASettingList
      __typename
    }
    message
    __typename
  }
}
`;
export const addUserToOrganization = /* GraphQL */ `mutation AddUserToOrganization(
  $email: String
  $organizationID: String
  $roles: [String]
) {
  addUserToOrganization(
    email: $email
    organizationID: $organizationID
    roles: $roles
  ) {
    statusCode
    user {
      id
      createdAt
      updatedAt
      name
      biography
      profileImage
      email
      background
      headline
      title
      enableAdminAgent
      __typename
    }
    userOrganization {
      id
      userID
      organizationID
      name
      superUser
      roles
      createdAt
      updatedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const resetPassword = /* GraphQL */ `mutation ResetPassword(
  $userId: String
  $password: String
  $forceChange: Boolean
) {
  resetPassword(
    userId: $userId
    password: $password
    forceChange: $forceChange
  ) {
    statusCode
    message
    __typename
  }
}
`;
export const deployOrganization = /* GraphQL */ `mutation DeployOrganization($organizationID: String!) {
  deployOrganization(organizationID: $organizationID) {
    id
    name
    createdAt
    updatedAt
    stripePublicKey
    stripeSecretKey
    googleApiConfig
    googleApiSyncInfo
    cognitoUserPoolID
    cognitoWebClientID
    cognitoIdentityPoolID
    signUpFields
    signUpRequiredFields
    appsyncGraphqlID
    appsyncGraphqlKey
    appsyncGraphqlUrl
    deployedAt
    deployStatus
    Courses {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      externalID
      name
      active
      headline
      description
      objectives
      tags
      keywords
      level
      length
      courseImage
      courseImageThumbnail
      promoVideo
      posterImage
      sharePassword
      audience
      requiredSkills
      gated
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      startDate
      expiryDate
      searchable
      sections
      reviews
      currency
      discountPercent
      avgRating
      reviewsCount
      courseLessons
      price
      sellPrice
      certification
      companyName
      enrollmentCount
      lessonCount
      faqs
      instructors
      searchInstructors
      ctaUrl
      ctaLabel
      ctaNewWindow
      accessConfiguration
      accessGroups
      excludeFromAllCourses
      portalKicker
      prerequisiteMessage
      prerequisiteCertificates
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      enrollmentOffered
      aiWizardContent
      discussionTopic
      doNotIndex
      doNotReference
      ogImage
      enableAutoplay
      __typename
    }
    Portals {
      id
      organizationID
      defaultLibraryID
      libraries
      libraryShares
      createdAt
      updatedAt
      name
      active
      publicName
      publicDomain
      sslDomain
      description
      type
      allowSearch
      enableInstructors
      requireSignature
      logoImage
      faviconImage
      ogImage
      categories
      pageDefaults
      pageRules
      componentConfigs
      termsOfService
      cardShowPrice
      publicCardShowActionButton
      publicCardButtonLabel
      publicCardAction
      publicLandingPageButtonLabel
      membershipCardShowActionButton
      membershipCardWithAccessButtonLabel
      membershipCardWithAccessAction
      membershipCardNoAccessButtonLabel
      membershipCardNoAccessAction
      membershipLandingPageWithAccessButtonLabel
      membershipLandingPageNoAccessButtonLabel
      membershipLandingPageNoAccessMembershipAction
      commerceCardShowActionButton
      commerceCardNoAccessButtonLabel
      commerceCardNoAccessAction
      commerceCardWithAccessButtonLabel
      commerceCardWithAccessAction
      commerceLandingPageWithAccessButtonLabel
      commerceLandingPageNoAccessButtonLabel
      commerceLandingPageNoAccessAction
      primaryMembershipID
      membershipOfferPageID
      noAccessImage
      learningBoardGroupNames
      stylesheet
      tokens
      supportedLocales
      defaultCheckoutConfirmationMessage
      courseCardShowImage
      courseCardShowTitle
      courseCardShowInstructor
      courseCardShowDesc
      courseCardShowInfoBar
      courseCardShowActionButton
      courseCardShowLessonCount
      showCertification
      orderConfirmationEmailID
      newCustomerMembershipID
      showLearningBoard
      showUserNameInLearningBoard
      trackDeskTenantId
      cloudfrontDistributionID
      cloudfrontDistributionDomain
      deployedAt
      deployStatus
      googleAnalyticsTagID
      programLandingWithAccessCourseAction
      footerScripts
      repositoryOriginAccessIdentityID
      clientAIAnswerLength
      clientAIFeedbackButtons
      clientAIPromptPlaceholder
      clientAISuggestedPrompts
      clientAIPersistentPrompts
      clientAIPromptTemplate
      clientAIStartingMessage
      clientAIInlineReferences
      clientAISuggestRefinements
      clientAIAdditionalInstructions
      clientAIConfig
      learningBoardConfig
      addToCartEnabled
      productCardConfig
      aiSearchConfig
      clientAIBaseUrl
      showQuizResultsTab
      status
      purgeStatus
      purgeSteps
      purgeError
      __typename
    }
    accessGroups
    enableDiscussionGroups
    enableAI
    defaultRoles
    enableMeetings
    enableHubs
    enableGeo
    clientAILanguageModel
    contentGenerationModel
    clientAIStatus
    crawlConfigs
    internalIpRanges
    usePostHnswFilter
    exportFullConversations
    syncConfigs
    searchGuidance
    status
    deletedAt
    deletedBy
    purgeScheduledAt
    purgeStatus
    purgeSteps
    purgeError
    clonedFromEnv
    clonedAt
    Users {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const previewOrganizationDeletion = /* GraphQL */ `mutation PreviewOrganizationDeletion($organizationID: String!) {
  previewOrganizationDeletion(organizationID: $organizationID) {
    organizationID
    organizationName
    portalCount
    portals {
      portalID
      portalName
      stackName
      dynamoCounts
      pgvectorRowCount
      __typename
    }
    dynamoCounts
    pgvectorRowCount
    repositoryBucketCount
    stacksToDestroy
    __typename
  }
}
`;
export const deleteOrganizationPermanently = /* GraphQL */ `mutation DeleteOrganizationPermanently(
  $organizationID: String!
  $confirmationPhrase: String!
) {
  deleteOrganizationPermanently(
    organizationID: $organizationID
    confirmationPhrase: $confirmationPhrase
  ) {
    id
    name
    createdAt
    updatedAt
    stripePublicKey
    stripeSecretKey
    googleApiConfig
    googleApiSyncInfo
    cognitoUserPoolID
    cognitoWebClientID
    cognitoIdentityPoolID
    signUpFields
    signUpRequiredFields
    appsyncGraphqlID
    appsyncGraphqlKey
    appsyncGraphqlUrl
    deployedAt
    deployStatus
    Courses {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      externalID
      name
      active
      headline
      description
      objectives
      tags
      keywords
      level
      length
      courseImage
      courseImageThumbnail
      promoVideo
      posterImage
      sharePassword
      audience
      requiredSkills
      gated
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      startDate
      expiryDate
      searchable
      sections
      reviews
      currency
      discountPercent
      avgRating
      reviewsCount
      courseLessons
      price
      sellPrice
      certification
      companyName
      enrollmentCount
      lessonCount
      faqs
      instructors
      searchInstructors
      ctaUrl
      ctaLabel
      ctaNewWindow
      accessConfiguration
      accessGroups
      excludeFromAllCourses
      portalKicker
      prerequisiteMessage
      prerequisiteCertificates
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      enrollmentOffered
      aiWizardContent
      discussionTopic
      doNotIndex
      doNotReference
      ogImage
      enableAutoplay
      __typename
    }
    Portals {
      id
      organizationID
      defaultLibraryID
      libraries
      libraryShares
      createdAt
      updatedAt
      name
      active
      publicName
      publicDomain
      sslDomain
      description
      type
      allowSearch
      enableInstructors
      requireSignature
      logoImage
      faviconImage
      ogImage
      categories
      pageDefaults
      pageRules
      componentConfigs
      termsOfService
      cardShowPrice
      publicCardShowActionButton
      publicCardButtonLabel
      publicCardAction
      publicLandingPageButtonLabel
      membershipCardShowActionButton
      membershipCardWithAccessButtonLabel
      membershipCardWithAccessAction
      membershipCardNoAccessButtonLabel
      membershipCardNoAccessAction
      membershipLandingPageWithAccessButtonLabel
      membershipLandingPageNoAccessButtonLabel
      membershipLandingPageNoAccessMembershipAction
      commerceCardShowActionButton
      commerceCardNoAccessButtonLabel
      commerceCardNoAccessAction
      commerceCardWithAccessButtonLabel
      commerceCardWithAccessAction
      commerceLandingPageWithAccessButtonLabel
      commerceLandingPageNoAccessButtonLabel
      commerceLandingPageNoAccessAction
      primaryMembershipID
      membershipOfferPageID
      noAccessImage
      learningBoardGroupNames
      stylesheet
      tokens
      supportedLocales
      defaultCheckoutConfirmationMessage
      courseCardShowImage
      courseCardShowTitle
      courseCardShowInstructor
      courseCardShowDesc
      courseCardShowInfoBar
      courseCardShowActionButton
      courseCardShowLessonCount
      showCertification
      orderConfirmationEmailID
      newCustomerMembershipID
      showLearningBoard
      showUserNameInLearningBoard
      trackDeskTenantId
      cloudfrontDistributionID
      cloudfrontDistributionDomain
      deployedAt
      deployStatus
      googleAnalyticsTagID
      programLandingWithAccessCourseAction
      footerScripts
      repositoryOriginAccessIdentityID
      clientAIAnswerLength
      clientAIFeedbackButtons
      clientAIPromptPlaceholder
      clientAISuggestedPrompts
      clientAIPersistentPrompts
      clientAIPromptTemplate
      clientAIStartingMessage
      clientAIInlineReferences
      clientAISuggestRefinements
      clientAIAdditionalInstructions
      clientAIConfig
      learningBoardConfig
      addToCartEnabled
      productCardConfig
      aiSearchConfig
      clientAIBaseUrl
      showQuizResultsTab
      status
      purgeStatus
      purgeSteps
      purgeError
      __typename
    }
    accessGroups
    enableDiscussionGroups
    enableAI
    defaultRoles
    enableMeetings
    enableHubs
    enableGeo
    clientAILanguageModel
    contentGenerationModel
    clientAIStatus
    crawlConfigs
    internalIpRanges
    usePostHnswFilter
    exportFullConversations
    syncConfigs
    searchGuidance
    status
    deletedAt
    deletedBy
    purgeScheduledAt
    purgeStatus
    purgeSteps
    purgeError
    clonedFromEnv
    clonedAt
    Users {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const hardDeleteOrganizationNow = /* GraphQL */ `mutation HardDeleteOrganizationNow(
  $organizationID: String!
  $confirmationPhrase: String!
) {
  hardDeleteOrganizationNow(
    organizationID: $organizationID
    confirmationPhrase: $confirmationPhrase
  ) {
    id
    name
    createdAt
    updatedAt
    stripePublicKey
    stripeSecretKey
    googleApiConfig
    googleApiSyncInfo
    cognitoUserPoolID
    cognitoWebClientID
    cognitoIdentityPoolID
    signUpFields
    signUpRequiredFields
    appsyncGraphqlID
    appsyncGraphqlKey
    appsyncGraphqlUrl
    deployedAt
    deployStatus
    Courses {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      externalID
      name
      active
      headline
      description
      objectives
      tags
      keywords
      level
      length
      courseImage
      courseImageThumbnail
      promoVideo
      posterImage
      sharePassword
      audience
      requiredSkills
      gated
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      startDate
      expiryDate
      searchable
      sections
      reviews
      currency
      discountPercent
      avgRating
      reviewsCount
      courseLessons
      price
      sellPrice
      certification
      companyName
      enrollmentCount
      lessonCount
      faqs
      instructors
      searchInstructors
      ctaUrl
      ctaLabel
      ctaNewWindow
      accessConfiguration
      accessGroups
      excludeFromAllCourses
      portalKicker
      prerequisiteMessage
      prerequisiteCertificates
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      enrollmentOffered
      aiWizardContent
      discussionTopic
      doNotIndex
      doNotReference
      ogImage
      enableAutoplay
      __typename
    }
    Portals {
      id
      organizationID
      defaultLibraryID
      libraries
      libraryShares
      createdAt
      updatedAt
      name
      active
      publicName
      publicDomain
      sslDomain
      description
      type
      allowSearch
      enableInstructors
      requireSignature
      logoImage
      faviconImage
      ogImage
      categories
      pageDefaults
      pageRules
      componentConfigs
      termsOfService
      cardShowPrice
      publicCardShowActionButton
      publicCardButtonLabel
      publicCardAction
      publicLandingPageButtonLabel
      membershipCardShowActionButton
      membershipCardWithAccessButtonLabel
      membershipCardWithAccessAction
      membershipCardNoAccessButtonLabel
      membershipCardNoAccessAction
      membershipLandingPageWithAccessButtonLabel
      membershipLandingPageNoAccessButtonLabel
      membershipLandingPageNoAccessMembershipAction
      commerceCardShowActionButton
      commerceCardNoAccessButtonLabel
      commerceCardNoAccessAction
      commerceCardWithAccessButtonLabel
      commerceCardWithAccessAction
      commerceLandingPageWithAccessButtonLabel
      commerceLandingPageNoAccessButtonLabel
      commerceLandingPageNoAccessAction
      primaryMembershipID
      membershipOfferPageID
      noAccessImage
      learningBoardGroupNames
      stylesheet
      tokens
      supportedLocales
      defaultCheckoutConfirmationMessage
      courseCardShowImage
      courseCardShowTitle
      courseCardShowInstructor
      courseCardShowDesc
      courseCardShowInfoBar
      courseCardShowActionButton
      courseCardShowLessonCount
      showCertification
      orderConfirmationEmailID
      newCustomerMembershipID
      showLearningBoard
      showUserNameInLearningBoard
      trackDeskTenantId
      cloudfrontDistributionID
      cloudfrontDistributionDomain
      deployedAt
      deployStatus
      googleAnalyticsTagID
      programLandingWithAccessCourseAction
      footerScripts
      repositoryOriginAccessIdentityID
      clientAIAnswerLength
      clientAIFeedbackButtons
      clientAIPromptPlaceholder
      clientAISuggestedPrompts
      clientAIPersistentPrompts
      clientAIPromptTemplate
      clientAIStartingMessage
      clientAIInlineReferences
      clientAISuggestRefinements
      clientAIAdditionalInstructions
      clientAIConfig
      learningBoardConfig
      addToCartEnabled
      productCardConfig
      aiSearchConfig
      clientAIBaseUrl
      showQuizResultsTab
      status
      purgeStatus
      purgeSteps
      purgeError
      __typename
    }
    accessGroups
    enableDiscussionGroups
    enableAI
    defaultRoles
    enableMeetings
    enableHubs
    enableGeo
    clientAILanguageModel
    contentGenerationModel
    clientAIStatus
    crawlConfigs
    internalIpRanges
    usePostHnswFilter
    exportFullConversations
    syncConfigs
    searchGuidance
    status
    deletedAt
    deletedBy
    purgeScheduledAt
    purgeStatus
    purgeSteps
    purgeError
    clonedFromEnv
    clonedAt
    Users {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const cancelOrganizationDeletion = /* GraphQL */ `mutation CancelOrganizationDeletion($organizationID: String!) {
  cancelOrganizationDeletion(organizationID: $organizationID) {
    id
    name
    createdAt
    updatedAt
    stripePublicKey
    stripeSecretKey
    googleApiConfig
    googleApiSyncInfo
    cognitoUserPoolID
    cognitoWebClientID
    cognitoIdentityPoolID
    signUpFields
    signUpRequiredFields
    appsyncGraphqlID
    appsyncGraphqlKey
    appsyncGraphqlUrl
    deployedAt
    deployStatus
    Courses {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      externalID
      name
      active
      headline
      description
      objectives
      tags
      keywords
      level
      length
      courseImage
      courseImageThumbnail
      promoVideo
      posterImage
      sharePassword
      audience
      requiredSkills
      gated
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      startDate
      expiryDate
      searchable
      sections
      reviews
      currency
      discountPercent
      avgRating
      reviewsCount
      courseLessons
      price
      sellPrice
      certification
      companyName
      enrollmentCount
      lessonCount
      faqs
      instructors
      searchInstructors
      ctaUrl
      ctaLabel
      ctaNewWindow
      accessConfiguration
      accessGroups
      excludeFromAllCourses
      portalKicker
      prerequisiteMessage
      prerequisiteCertificates
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      enrollmentOffered
      aiWizardContent
      discussionTopic
      doNotIndex
      doNotReference
      ogImage
      enableAutoplay
      __typename
    }
    Portals {
      id
      organizationID
      defaultLibraryID
      libraries
      libraryShares
      createdAt
      updatedAt
      name
      active
      publicName
      publicDomain
      sslDomain
      description
      type
      allowSearch
      enableInstructors
      requireSignature
      logoImage
      faviconImage
      ogImage
      categories
      pageDefaults
      pageRules
      componentConfigs
      termsOfService
      cardShowPrice
      publicCardShowActionButton
      publicCardButtonLabel
      publicCardAction
      publicLandingPageButtonLabel
      membershipCardShowActionButton
      membershipCardWithAccessButtonLabel
      membershipCardWithAccessAction
      membershipCardNoAccessButtonLabel
      membershipCardNoAccessAction
      membershipLandingPageWithAccessButtonLabel
      membershipLandingPageNoAccessButtonLabel
      membershipLandingPageNoAccessMembershipAction
      commerceCardShowActionButton
      commerceCardNoAccessButtonLabel
      commerceCardNoAccessAction
      commerceCardWithAccessButtonLabel
      commerceCardWithAccessAction
      commerceLandingPageWithAccessButtonLabel
      commerceLandingPageNoAccessButtonLabel
      commerceLandingPageNoAccessAction
      primaryMembershipID
      membershipOfferPageID
      noAccessImage
      learningBoardGroupNames
      stylesheet
      tokens
      supportedLocales
      defaultCheckoutConfirmationMessage
      courseCardShowImage
      courseCardShowTitle
      courseCardShowInstructor
      courseCardShowDesc
      courseCardShowInfoBar
      courseCardShowActionButton
      courseCardShowLessonCount
      showCertification
      orderConfirmationEmailID
      newCustomerMembershipID
      showLearningBoard
      showUserNameInLearningBoard
      trackDeskTenantId
      cloudfrontDistributionID
      cloudfrontDistributionDomain
      deployedAt
      deployStatus
      googleAnalyticsTagID
      programLandingWithAccessCourseAction
      footerScripts
      repositoryOriginAccessIdentityID
      clientAIAnswerLength
      clientAIFeedbackButtons
      clientAIPromptPlaceholder
      clientAISuggestedPrompts
      clientAIPersistentPrompts
      clientAIPromptTemplate
      clientAIStartingMessage
      clientAIInlineReferences
      clientAISuggestRefinements
      clientAIAdditionalInstructions
      clientAIConfig
      learningBoardConfig
      addToCartEnabled
      productCardConfig
      aiSearchConfig
      clientAIBaseUrl
      showQuizResultsTab
      status
      purgeStatus
      purgeSteps
      purgeError
      __typename
    }
    accessGroups
    enableDiscussionGroups
    enableAI
    defaultRoles
    enableMeetings
    enableHubs
    enableGeo
    clientAILanguageModel
    contentGenerationModel
    clientAIStatus
    crawlConfigs
    internalIpRanges
    usePostHnswFilter
    exportFullConversations
    syncConfigs
    searchGuidance
    status
    deletedAt
    deletedBy
    purgeScheduledAt
    purgeStatus
    purgeSteps
    purgeError
    clonedFromEnv
    clonedAt
    Users {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const previewPortalDeletion = /* GraphQL */ `mutation PreviewPortalDeletion($organizationID: String!, $portalID: String!) {
  previewPortalDeletion(organizationID: $organizationID, portalID: $portalID) {
    portalID
    portalName
    stackName
    dynamoCounts
    pgvectorRowCount
    __typename
  }
}
`;
export const deletePortalPermanently = /* GraphQL */ `mutation DeletePortalPermanently(
  $organizationID: String!
  $portalID: String!
  $confirmationPhrase: String!
) {
  deletePortalPermanently(
    organizationID: $organizationID
    portalID: $portalID
    confirmationPhrase: $confirmationPhrase
  ) {
    id
    organizationID
    defaultLibraryID
    libraries
    libraryShares
    createdAt
    updatedAt
    name
    active
    publicName
    publicDomain
    sslDomain
    description
    type
    allowSearch
    enableInstructors
    requireSignature
    defaultInstructorImage {
      id
      organizationID
      createdAt
      updatedAt
      externalID
      repositoryID
      name
      key
      description
      type
      tags
      mimeType
      derivativeStatus
      transcribeStatus
      status
      access
      dominantColor
      length
      transcript
      scormManifest
      useHls
      hlsGenerated
      __typename
    }
    logoImage
    faviconImage
    ogImage
    categories
    pageDefaults
    pageRules
    componentConfigs
    termsOfService
    cardShowPrice
    publicCardShowActionButton
    publicCardButtonLabel
    publicCardAction
    publicLandingPageButtonLabel
    membershipCardShowActionButton
    membershipCardWithAccessButtonLabel
    membershipCardWithAccessAction
    membershipCardNoAccessButtonLabel
    membershipCardNoAccessAction
    membershipLandingPageWithAccessButtonLabel
    membershipLandingPageNoAccessButtonLabel
    membershipLandingPageNoAccessMembershipAction
    commerceCardShowActionButton
    commerceCardNoAccessButtonLabel
    commerceCardNoAccessAction
    commerceCardWithAccessButtonLabel
    commerceCardWithAccessAction
    commerceLandingPageWithAccessButtonLabel
    commerceLandingPageNoAccessButtonLabel
    commerceLandingPageNoAccessAction
    primaryMembershipID
    membershipOfferPageID
    noAccessImage
    learningBoardGroupNames
    stylesheet
    tokens
    supportedLocales
    defaultCheckoutConfirmationMessage
    courseCardShowImage
    courseCardShowTitle
    courseCardShowInstructor
    courseCardShowDesc
    courseCardShowInfoBar
    courseCardShowActionButton
    courseCardShowLessonCount
    showCertification
    orderConfirmationEmailID
    newCustomerMembershipID
    showLearningBoard
    showUserNameInLearningBoard
    trackDeskTenantId
    cloudfrontDistributionID
    cloudfrontDistributionDomain
    deployedAt
    deployStatus
    googleAnalyticsTagID
    programLandingWithAccessCourseAction
    footerScripts
    repositoryOriginAccessIdentityID
    clientAIAnswerLength
    clientAIFeedbackButtons
    clientAIPromptPlaceholder
    clientAISuggestedPrompts
    clientAIPersistentPrompts
    clientAIPromptTemplate
    clientAIStartingMessage
    clientAIInlineReferences
    clientAISuggestRefinements
    clientAIAdditionalInstructions
    clientAIConfig
    learningBoardConfig
    addToCartEnabled
    productCardConfig
    aiSearchConfig
    clientAIBaseUrl
    showQuizResultsTab
    status
    purgeStatus
    purgeSteps
    purgeError
    __typename
  }
}
`;
export const deployPortal = /* GraphQL */ `mutation DeployPortal($organizationID: String!, $portalID: String!) {
  deployPortal(organizationID: $organizationID, portalID: $portalID) {
    id
    organizationID
    defaultLibraryID
    libraries
    libraryShares
    createdAt
    updatedAt
    name
    active
    publicName
    publicDomain
    sslDomain
    description
    type
    allowSearch
    enableInstructors
    requireSignature
    defaultInstructorImage {
      id
      organizationID
      createdAt
      updatedAt
      externalID
      repositoryID
      name
      key
      description
      type
      tags
      mimeType
      derivativeStatus
      transcribeStatus
      status
      access
      dominantColor
      length
      transcript
      scormManifest
      useHls
      hlsGenerated
      __typename
    }
    logoImage
    faviconImage
    ogImage
    categories
    pageDefaults
    pageRules
    componentConfigs
    termsOfService
    cardShowPrice
    publicCardShowActionButton
    publicCardButtonLabel
    publicCardAction
    publicLandingPageButtonLabel
    membershipCardShowActionButton
    membershipCardWithAccessButtonLabel
    membershipCardWithAccessAction
    membershipCardNoAccessButtonLabel
    membershipCardNoAccessAction
    membershipLandingPageWithAccessButtonLabel
    membershipLandingPageNoAccessButtonLabel
    membershipLandingPageNoAccessMembershipAction
    commerceCardShowActionButton
    commerceCardNoAccessButtonLabel
    commerceCardNoAccessAction
    commerceCardWithAccessButtonLabel
    commerceCardWithAccessAction
    commerceLandingPageWithAccessButtonLabel
    commerceLandingPageNoAccessButtonLabel
    commerceLandingPageNoAccessAction
    primaryMembershipID
    membershipOfferPageID
    noAccessImage
    learningBoardGroupNames
    stylesheet
    tokens
    supportedLocales
    defaultCheckoutConfirmationMessage
    courseCardShowImage
    courseCardShowTitle
    courseCardShowInstructor
    courseCardShowDesc
    courseCardShowInfoBar
    courseCardShowActionButton
    courseCardShowLessonCount
    showCertification
    orderConfirmationEmailID
    newCustomerMembershipID
    showLearningBoard
    showUserNameInLearningBoard
    trackDeskTenantId
    cloudfrontDistributionID
    cloudfrontDistributionDomain
    deployedAt
    deployStatus
    googleAnalyticsTagID
    programLandingWithAccessCourseAction
    footerScripts
    repositoryOriginAccessIdentityID
    clientAIAnswerLength
    clientAIFeedbackButtons
    clientAIPromptPlaceholder
    clientAISuggestedPrompts
    clientAIPersistentPrompts
    clientAIPromptTemplate
    clientAIStartingMessage
    clientAIInlineReferences
    clientAISuggestRefinements
    clientAIAdditionalInstructions
    clientAIConfig
    learningBoardConfig
    addToCartEnabled
    productCardConfig
    aiSearchConfig
    clientAIBaseUrl
    showQuizResultsTab
    status
    purgeStatus
    purgeSteps
    purgeError
    __typename
  }
}
`;
export const deployRepository = /* GraphQL */ `mutation DeployRepository($organizationID: String!, $repositoryID: String!) {
  deployRepository(
    organizationID: $organizationID
    repositoryID: $repositoryID
  ) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    bucket
    cdnPath
    status
    cloudfrontDistributionDomain
    cloudfrontDistributionID
    cloudfrontOriginAccessIdentity
    deployedAt
    deployStatus
    signingKeyID
    __typename
  }
}
`;
export const registerForMeeting = /* GraphQL */ `mutation RegisterForMeeting(
  $meetingKey: String!
  $portalID: String
  $organizationID: String
) {
  registerForMeeting(
    meetingKey: $meetingKey
    portalID: $portalID
    organizationID: $organizationID
  ) {
    Meeting {
      id
      organizationID
      slug
      libraries
      portalID
      meetingType
      status
      createdAt
      createdByID
      updatedAt
      name
      headline
      description
      content
      instructors
      searchInstructors
      transcript
      image
      recordingID
      recordingMediaPipelineID
      preStartOpenDuration
      startsAt
      postStartGraceDuration
      plannedDuration
      actualDuration
      preMeetingMessage
      postMeetingMessage
      mediaRegion
      registrationRequired
      registerBy
      restrictByAccessGroup
      accessGroups
      restrictByCustomer
      customers
      registrationCount
      registrationMax
      portalKicker
      attendees
      __typename
    }
    Registration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    statusCode
    message
    __typename
  }
}
`;
export const startMeeting = /* GraphQL */ `mutation StartMeeting(
  $meetingKey: String
  $organizationID: ID
  $region: String
) {
  startMeeting(
    meetingKey: $meetingKey
    organizationID: $organizationID
    region: $region
  ) {
    Meeting {
      id
      organizationID
      slug
      libraries
      portalID
      meetingType
      status
      createdAt
      createdByID
      updatedAt
      name
      headline
      description
      content
      instructors
      searchInstructors
      transcript
      image
      recordingID
      recordingMediaPipelineID
      preStartOpenDuration
      startsAt
      postStartGraceDuration
      plannedDuration
      actualDuration
      preMeetingMessage
      postMeetingMessage
      mediaRegion
      registrationRequired
      registerBy
      restrictByAccessGroup
      accessGroups
      restrictByCustomer
      customers
      registrationCount
      registrationMax
      portalKicker
      attendees
      __typename
    }
    Registration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    CurrentAttendee {
      AttendeeId
      ExternalUserId
      JoinToken
      __typename
    }
    Attendees {
      AttendeeId
      ExternalUserId
      JoinToken
      __typename
    }
    statusCode
    message
    __typename
  }
}
`;
export const startMeetingRecording = /* GraphQL */ `mutation StartMeetingRecording(
  $organizationID: ID!
  $portalID: ID!
  $meetingKey: ID!
) {
  startMeetingRecording(
    organizationID: $organizationID
    portalID: $portalID
    meetingKey: $meetingKey
  ) {
    Meeting {
      id
      organizationID
      slug
      libraries
      portalID
      meetingType
      status
      createdAt
      createdByID
      updatedAt
      name
      headline
      description
      content
      instructors
      searchInstructors
      transcript
      image
      recordingID
      recordingMediaPipelineID
      preStartOpenDuration
      startsAt
      postStartGraceDuration
      plannedDuration
      actualDuration
      preMeetingMessage
      postMeetingMessage
      mediaRegion
      registrationRequired
      registerBy
      restrictByAccessGroup
      accessGroups
      restrictByCustomer
      customers
      registrationCount
      registrationMax
      portalKicker
      attendees
      __typename
    }
    statusCode
    message
    __typename
  }
}
`;
export const stopMeetingRecording = /* GraphQL */ `mutation StopMeetingRecording(
  $organizationID: ID!
  $portalID: ID!
  $meetingKey: ID!
) {
  stopMeetingRecording(
    organizationID: $organizationID
    portalID: $portalID
    meetingKey: $meetingKey
  ) {
    Meeting {
      id
      organizationID
      slug
      libraries
      portalID
      meetingType
      status
      createdAt
      createdByID
      updatedAt
      name
      headline
      description
      content
      instructors
      searchInstructors
      transcript
      image
      recordingID
      recordingMediaPipelineID
      preStartOpenDuration
      startsAt
      postStartGraceDuration
      plannedDuration
      actualDuration
      preMeetingMessage
      postMeetingMessage
      mediaRegion
      registrationRequired
      registerBy
      restrictByAccessGroup
      accessGroups
      restrictByCustomer
      customers
      registrationCount
      registrationMax
      portalKicker
      attendees
      __typename
    }
    statusCode
    message
    __typename
  }
}
`;
export const getGoogleAccessToken = /* GraphQL */ `mutation GetGoogleAccessToken(
  $organizationID: String!
  $authorizationCode: String
  $redirectUri: String
) {
  getGoogleAccessToken(
    organizationID: $organizationID
    authorizationCode: $authorizationCode
    redirectUri: $redirectUri
  ) {
    statusCode
    accessToken
    message
    __typename
  }
}
`;
export const syncDriveFiles = /* GraphQL */ `mutation SyncDriveFiles(
  $folderIds: [String]!
  $organizationID: String!
  $repositoryID: String!
  $libraryID: String!
) {
  syncDriveFiles(
    folderIds: $folderIds
    organizationID: $organizationID
    repositoryID: $repositoryID
    libraryID: $libraryID
  ) {
    statusCode
    message
    results {
      id
      organizationID
      createdAt
      updatedAt
      externalID
      repositoryID
      name
      key
      description
      type
      tags
      mimeType
      derivativeStatus
      transcribeStatus
      status
      access
      dominantColor
      length
      transcript
      scormManifest
      useHls
      hlsGenerated
      __typename
    }
    __typename
  }
}
`;
export const joinMeeting = /* GraphQL */ `mutation JoinMeeting(
  $organizationID: ID!
  $portalID: ID!
  $meetingKey: ID!
  $attendeeName: String
) {
  joinMeeting(
    organizationID: $organizationID
    portalID: $portalID
    meetingKey: $meetingKey
    attendeeName: $attendeeName
  ) {
    Meeting {
      id
      organizationID
      slug
      libraries
      portalID
      meetingType
      status
      createdAt
      createdByID
      updatedAt
      name
      headline
      description
      content
      instructors
      searchInstructors
      transcript
      image
      recordingID
      recordingMediaPipelineID
      preStartOpenDuration
      startsAt
      postStartGraceDuration
      plannedDuration
      actualDuration
      preMeetingMessage
      postMeetingMessage
      mediaRegion
      registrationRequired
      registerBy
      restrictByAccessGroup
      accessGroups
      restrictByCustomer
      customers
      registrationCount
      registrationMax
      portalKicker
      attendees
      __typename
    }
    Registration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    CurrentAttendee {
      AttendeeId
      ExternalUserId
      JoinToken
      __typename
    }
    Attendees {
      AttendeeId
      ExternalUserId
      JoinToken
      __typename
    }
    statusCode
    message
    __typename
  }
}
`;
export const endMeeting = /* GraphQL */ `mutation EndMeeting($organizationID: ID!, $portalID: ID!, $meetingKey: ID!) {
  endMeeting(
    organizationID: $organizationID
    portalID: $portalID
    meetingKey: $meetingKey
  ) {
    Meeting {
      id
      organizationID
      slug
      libraries
      portalID
      meetingType
      status
      createdAt
      createdByID
      updatedAt
      name
      headline
      description
      content
      instructors
      searchInstructors
      transcript
      image
      recordingID
      recordingMediaPipelineID
      preStartOpenDuration
      startsAt
      postStartGraceDuration
      plannedDuration
      actualDuration
      preMeetingMessage
      postMeetingMessage
      mediaRegion
      registrationRequired
      registerBy
      restrictByAccessGroup
      accessGroups
      restrictByCustomer
      customers
      registrationCount
      registrationMax
      portalKicker
      attendees
      __typename
    }
    Registration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    CurrentAttendee {
      AttendeeId
      ExternalUserId
      JoinToken
      __typename
    }
    Attendees {
      AttendeeId
      ExternalUserId
      JoinToken
      __typename
    }
    statusCode
    message
    __typename
  }
}
`;
export const getChimeAttendee = /* GraphQL */ `mutation GetChimeAttendee(
  $organizationID: ID!
  $portalID: ID!
  $meetingKey: ID!
) {
  getChimeAttendee(
    organizationID: $organizationID
    portalID: $portalID
    meetingKey: $meetingKey
  ) {
    Meeting {
      id
      organizationID
      slug
      libraries
      portalID
      meetingType
      status
      createdAt
      createdByID
      updatedAt
      name
      headline
      description
      content
      instructors
      searchInstructors
      transcript
      image
      recordingID
      recordingMediaPipelineID
      preStartOpenDuration
      startsAt
      postStartGraceDuration
      plannedDuration
      actualDuration
      preMeetingMessage
      postMeetingMessage
      mediaRegion
      registrationRequired
      registerBy
      restrictByAccessGroup
      accessGroups
      restrictByCustomer
      customers
      registrationCount
      registrationMax
      portalKicker
      attendees
      __typename
    }
    Registration {
      id
      organizationID
      portalID
      customerID
      meetingID
      name
      status
      createdAt
      updatedAt
      notes
      history
      __typename
    }
    CurrentAttendee {
      AttendeeId
      ExternalUserId
      JoinToken
      __typename
    }
    Attendees {
      AttendeeId
      ExternalUserId
      JoinToken
      __typename
    }
    statusCode
    message
    __typename
  }
}
`;
export const startCrawl = /* GraphQL */ `mutation StartCrawl($organizationID: ID!, $crawlID: ID!) {
  startCrawl(organizationID: $organizationID, crawlID: $crawlID) {
    statusCode
    organization {
      id
      name
      createdAt
      updatedAt
      stripePublicKey
      stripeSecretKey
      googleApiConfig
      googleApiSyncInfo
      cognitoUserPoolID
      cognitoWebClientID
      cognitoIdentityPoolID
      signUpFields
      signUpRequiredFields
      appsyncGraphqlID
      appsyncGraphqlKey
      appsyncGraphqlUrl
      deployedAt
      deployStatus
      accessGroups
      enableDiscussionGroups
      enableAI
      defaultRoles
      enableMeetings
      enableHubs
      enableGeo
      clientAILanguageModel
      contentGenerationModel
      clientAIStatus
      crawlConfigs
      internalIpRanges
      usePostHnswFilter
      exportFullConversations
      syncConfigs
      searchGuidance
      status
      deletedAt
      deletedBy
      purgeScheduledAt
      purgeStatus
      purgeSteps
      purgeError
      clonedFromEnv
      clonedAt
      __typename
    }
    message
    __typename
  }
}
`;
export const generateProductSheet = /* GraphQL */ `mutation GenerateProductSheet($organizationID: String!, $productID: String!) {
  generateProductSheet(organizationID: $organizationID, productID: $productID)
}
`;
export const reSyncProduct = /* GraphQL */ `mutation ReSyncProduct($organizationID: String!, $productID: String!) {
  reSyncProduct(organizationID: $organizationID, productID: $productID) {
    status
    message
    product {
      id
      organizationID
      syncConfigID
      handle
      name
      bodyHtml
      vendor
      productType
      imageSrc
      url
      tags
      status
      optionTypes
      productData
      catalogCategorization
      attributes
      productSheet
      externalIDs
      variants
      relatedGuideIds
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
`;
export const generateProductPageContent = /* GraphQL */ `mutation GenerateProductPageContent(
  $organizationID: String!
  $productID: String!
  $portalID: String
  $locale: String
  $modelOverride: String
) {
  generateProductPageContent(
    organizationID: $organizationID
    productID: $productID
    portalID: $portalID
    locale: $locale
    modelOverride: $modelOverride
  ) {
    status
    message
    createdAt
    systemPrompt
    modelID
    suggestedPrompts
    smartSummary {
      header
      generatedByAiLabel
      __typename
    }
    seoContent {
      metaDescription
      geoSummary
      __typename
    }
    __typename
  }
}
`;
export const regeneratePortalSuggestedPromptAnswer = /* GraphQL */ `mutation RegeneratePortalSuggestedPromptAnswer(
  $organizationID: String!
  $portalID: String!
  $promptType: String!
  $prompt: String!
  $locale: String
) {
  regeneratePortalSuggestedPromptAnswer(
    organizationID: $organizationID
    portalID: $portalID
    promptType: $promptType
    prompt: $prompt
    locale: $locale
  ) {
    status
    message
    prompt
    promptType
    answer
    cachedAt
    __typename
  }
}
`;
export const runProductFeed = /* GraphQL */ `mutation RunProductFeed(
  $organizationID: String!
  $fullLoad: Boolean
  $syncConfigID: String
) {
  runProductFeed(
    organizationID: $organizationID
    fullLoad: $fullLoad
    syncConfigID: $syncConfigID
  )
}
`;
export const refreshSearchGuidance = /* GraphQL */ `mutation RefreshSearchGuidance($organizationID: String!) {
  refreshSearchGuidance(organizationID: $organizationID)
}
`;
export const enableWebPixel = /* GraphQL */ `mutation EnableWebPixel($organizationID: String!, $shopifyConfigId: String!) {
  enableWebPixel(
    organizationID: $organizationID
    shopifyConfigId: $shopifyConfigId
  ) {
    success
    message
    __typename
  }
}
`;
export const disableWebPixel = /* GraphQL */ `mutation DisableWebPixel($organizationID: String!, $shopifyConfigId: String!) {
  disableWebPixel(
    organizationID: $organizationID
    shopifyConfigId: $shopifyConfigId
  ) {
    success
    message
    __typename
  }
}
`;
export const classifyConversation = /* GraphQL */ `mutation ClassifyConversation(
  $organizationID: String!
  $conversationID: String!
) {
  classifyConversation(
    organizationID: $organizationID
    conversationID: $conversationID
  ) {
    statusCode
    conversationID
    organizationID
    classification
    conversationData
    __typename
  }
}
`;
export const saveTopicsHierarchy = /* GraphQL */ `mutation SaveTopicsHierarchy($organizationID: String!, $topics: AWSJSON!) {
  saveTopicsHierarchy(organizationID: $organizationID, topics: $topics) {
    statusCode
    message
    results
    __typename
  }
}
`;
export const cancelAdminTask = /* GraphQL */ `mutation CancelAdminTask($organizationID: ID!, $id: ID!) {
  cancelAdminTask(organizationID: $organizationID, id: $id)
}
`;
export const retryAdminTask = /* GraphQL */ `mutation RetryAdminTask($organizationID: ID!, $id: ID!) {
  retryAdminTask(organizationID: $organizationID, id: $id)
}
`;
export const askAdminAgent = /* GraphQL */ `mutation AskAdminAgent(
  $organizationID: ID!
  $portalID: ID
  $question: String!
  $formContext: AWSJSON
) {
  askAdminAgent(
    organizationID: $organizationID
    portalID: $portalID
    question: $question
    formContext: $formContext
  )
}
`;
export const suggestTrackedPrompts = /* GraphQL */ `mutation SuggestTrackedPrompts(
  $organizationID: ID!
  $portalID: ID
  $context: AWSJSON
) {
  suggestTrackedPrompts(
    organizationID: $organizationID
    portalID: $portalID
    context: $context
  )
}
`;
export const suggestBrandProfile = /* GraphQL */ `mutation SuggestBrandProfile(
  $organizationID: ID!
  $portalID: ID
  $siteUrl: String!
  $hint: String
) {
  suggestBrandProfile(
    organizationID: $organizationID
    portalID: $portalID
    siteUrl: $siteUrl
    hint: $hint
  )
}
`;
export const runCompetitiveAudit = /* GraphQL */ `mutation RunCompetitiveAudit(
  $organizationID: ID!
  $portalID: ID
  $competitorUrls: [String!]!
  $brandProfile: AWSJSON
  $options: AWSJSON
) {
  runCompetitiveAudit(
    organizationID: $organizationID
    portalID: $portalID
    competitorUrls: $competitorUrls
    brandProfile: $brandProfile
    options: $options
  )
}
`;
export const runVisibilityBaseline = /* GraphQL */ `mutation RunVisibilityBaseline(
  $organizationID: ID!
  $portalID: ID
  $brandProfile: AWSJSON
  $seedPrompts: [String!]
) {
  runVisibilityBaseline(
    organizationID: $organizationID
    portalID: $portalID
    brandProfile: $brandProfile
    seedPrompts: $seedPrompts
  )
}
`;
export const runGuideMaintenance = /* GraphQL */ `mutation RunGuideMaintenance($organizationID: ID!, $portalID: ID) {
  runGuideMaintenance(organizationID: $organizationID, portalID: $portalID) {
    statusCode
    taskId
    message
    error
    __typename
  }
}
`;
export const suggestPrompts = /* GraphQL */ `mutation SuggestPrompts($organizationID: ID!, $portalID: ID, $clusterID: ID!) {
  suggestPrompts(
    organizationID: $organizationID
    portalID: $portalID
    clusterID: $clusterID
  ) {
    statusCode
    prompts {
      text
      rationale
      __typename
    }
    error
    __typename
  }
}
`;
export const ingestParquetConversations = /* GraphQL */ `mutation IngestParquetConversations(
  $organizationID: ID!
  $portalID: ID
  $options: AWSJSON
) {
  ingestParquetConversations(
    organizationID: $organizationID
    portalID: $portalID
    options: $options
  )
}
`;
export const submitChangeSet = /* GraphQL */ `mutation SubmitChangeSet($organizationID: ID!, $changeSetId: ID!) {
  submitChangeSet(organizationID: $organizationID, changeSetId: $changeSetId)
}
`;
export const approveChangeSet = /* GraphQL */ `mutation ApproveChangeSet(
  $organizationID: ID!
  $changeSetId: ID!
  $itemIds: [ID!]
) {
  approveChangeSet(
    organizationID: $organizationID
    changeSetId: $changeSetId
    itemIds: $itemIds
  )
}
`;
export const rejectChangeSet = /* GraphQL */ `mutation RejectChangeSet(
  $organizationID: ID!
  $changeSetId: ID!
  $itemIds: [ID!]
  $note: String
) {
  rejectChangeSet(
    organizationID: $organizationID
    changeSetId: $changeSetId
    itemIds: $itemIds
    note: $note
  )
}
`;
export const publishChangeSet = /* GraphQL */ `mutation PublishChangeSet($organizationID: ID!, $changeSetId: ID!) {
  publishChangeSet(organizationID: $organizationID, changeSetId: $changeSetId)
}
`;
export const triggerVisibilityScan = /* GraphQL */ `mutation TriggerVisibilityScan(
  $organizationID: ID!
  $portalID: ID
  $promptIDs: [ID!]
) {
  triggerVisibilityScan(
    organizationID: $organizationID
    portalID: $portalID
    promptIDs: $promptIDs
  )
}
`;
export const startGeoDiscovery = /* GraphQL */ `mutation StartGeoDiscovery(
  $organizationID: ID!
  $portalID: ID
  $url: String!
  $inputParams: AWSJSON
) {
  startGeoDiscovery(
    organizationID: $organizationID
    portalID: $portalID
    url: $url
    inputParams: $inputParams
  ) {
    id
    organizationID
    portalID
    status
    inputUrl
    inputParams
    proposals
    outputSummary
    errorMessage
    userId
    relatedTaskId
    createdAt
    updatedAt
    completedAt
    __typename
  }
}
`;
export const cancelGeoDiscovery = /* GraphQL */ `mutation CancelGeoDiscovery($organizationID: ID!, $id: ID!) {
  cancelGeoDiscovery(organizationID: $organizationID, id: $id) {
    id
    organizationID
    portalID
    status
    inputUrl
    inputParams
    proposals
    outputSummary
    errorMessage
    userId
    relatedTaskId
    createdAt
    updatedAt
    completedAt
    __typename
  }
}
`;
export const completeGeoDiscovery = /* GraphQL */ `mutation CompleteGeoDiscovery(
  $organizationID: ID!
  $id: ID!
  $proposals: AWSJSON
  $errorMessage: String
) {
  completeGeoDiscovery(
    organizationID: $organizationID
    id: $id
    proposals: $proposals
    errorMessage: $errorMessage
  ) {
    id
    organizationID
    portalID
    status
    inputUrl
    inputParams
    proposals
    outputSummary
    errorMessage
    userId
    relatedTaskId
    createdAt
    updatedAt
    completedAt
    __typename
  }
}
`;
export const acceptDiscoveryProposal = /* GraphQL */ `mutation AcceptDiscoveryProposal(
  $organizationID: ID!
  $discoveryId: ID!
  $proposalId: ID!
  $modifiedPayload: AWSJSON
) {
  acceptDiscoveryProposal(
    organizationID: $organizationID
    discoveryId: $discoveryId
    proposalId: $proposalId
    modifiedPayload: $modifiedPayload
  ) {
    id
    organizationID
    portalID
    status
    inputUrl
    inputParams
    proposals
    outputSummary
    errorMessage
    userId
    relatedTaskId
    createdAt
    updatedAt
    completedAt
    __typename
  }
}
`;
export const rejectDiscoveryProposal = /* GraphQL */ `mutation RejectDiscoveryProposal(
  $organizationID: ID!
  $discoveryId: ID!
  $proposalId: ID!
  $reason: String
) {
  rejectDiscoveryProposal(
    organizationID: $organizationID
    discoveryId: $discoveryId
    proposalId: $proposalId
    reason: $reason
  ) {
    id
    organizationID
    portalID
    status
    inputUrl
    inputParams
    proposals
    outputSummary
    errorMessage
    userId
    relatedTaskId
    createdAt
    updatedAt
    completedAt
    __typename
  }
}
`;
export const bulkAcceptProposals = /* GraphQL */ `mutation BulkAcceptProposals(
  $organizationID: ID!
  $discoveryId: ID!
  $proposalIds: [ID!]!
) {
  bulkAcceptProposals(
    organizationID: $organizationID
    discoveryId: $discoveryId
    proposalIds: $proposalIds
  ) {
    id
    organizationID
    portalID
    status
    inputUrl
    inputParams
    proposals
    outputSummary
    errorMessage
    userId
    relatedTaskId
    createdAt
    updatedAt
    completedAt
    __typename
  }
}
`;
export const bulkRejectProposals = /* GraphQL */ `mutation BulkRejectProposals(
  $organizationID: ID!
  $discoveryId: ID!
  $proposalIds: [ID!]!
) {
  bulkRejectProposals(
    organizationID: $organizationID
    discoveryId: $discoveryId
    proposalIds: $proposalIds
  ) {
    id
    organizationID
    portalID
    status
    inputUrl
    inputParams
    proposals
    outputSummary
    errorMessage
    userId
    relatedTaskId
    createdAt
    updatedAt
    completedAt
    __typename
  }
}
`;
export const createAsset = /* GraphQL */ `mutation CreateAsset(
  $input: CreateAssetInput!
  $condition: ModelAssetConditionInput
) {
  createAsset(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    externalID
    repositoryID
    name
    key
    description
    type
    tags
    mimeType
    derivativeStatus
    transcribeStatus
    status
    access
    dominantColor
    length
    transcript
    scormManifest
    useHls
    hlsGenerated
    __typename
  }
}
`;
export const updateAsset = /* GraphQL */ `mutation UpdateAsset(
  $input: UpdateAssetInput!
  $condition: ModelAssetConditionInput
) {
  updateAsset(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    externalID
    repositoryID
    name
    key
    description
    type
    tags
    mimeType
    derivativeStatus
    transcribeStatus
    status
    access
    dominantColor
    length
    transcript
    scormManifest
    useHls
    hlsGenerated
    __typename
  }
}
`;
export const deleteAsset = /* GraphQL */ `mutation DeleteAsset(
  $input: DeleteAssetInput!
  $condition: ModelAssetConditionInput
) {
  deleteAsset(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    externalID
    repositoryID
    name
    key
    description
    type
    tags
    mimeType
    derivativeStatus
    transcribeStatus
    status
    access
    dominantColor
    length
    transcript
    scormManifest
    useHls
    hlsGenerated
    __typename
  }
}
`;
export const createCertificate = /* GraphQL */ `mutation CreateCertificate(
  $input: CreateCertificateInput!
  $condition: ModelCertificateConditionInput
) {
  createCertificate(input: $input, condition: $condition) {
    id
    organizationID
    certificationID
    customerID
    createdAt
    updatedAt
    awardedAt
    score
    progressPercentage
    courseKey
    programKey
    __typename
  }
}
`;
export const updateCertificate = /* GraphQL */ `mutation UpdateCertificate(
  $input: UpdateCertificateInput!
  $condition: ModelCertificateConditionInput
) {
  updateCertificate(input: $input, condition: $condition) {
    id
    organizationID
    certificationID
    customerID
    createdAt
    updatedAt
    awardedAt
    score
    progressPercentage
    courseKey
    programKey
    __typename
  }
}
`;
export const deleteCertificate = /* GraphQL */ `mutation DeleteCertificate(
  $input: DeleteCertificateInput!
  $condition: ModelCertificateConditionInput
) {
  deleteCertificate(input: $input, condition: $condition) {
    id
    organizationID
    certificationID
    customerID
    createdAt
    updatedAt
    awardedAt
    score
    progressPercentage
    courseKey
    programKey
    __typename
  }
}
`;
export const createCertification = /* GraphQL */ `mutation CreateCertification(
  $input: CreateCertificationInput!
  $condition: ModelCertificationConditionInput
) {
  createCertification(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    template
    poster
    fields
    emailTemplateID
    __typename
  }
}
`;
export const updateCertification = /* GraphQL */ `mutation UpdateCertification(
  $input: UpdateCertificationInput!
  $condition: ModelCertificationConditionInput
) {
  updateCertification(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    template
    poster
    fields
    emailTemplateID
    __typename
  }
}
`;
export const deleteCertification = /* GraphQL */ `mutation DeleteCertification(
  $input: DeleteCertificationInput!
  $condition: ModelCertificationConditionInput
) {
  deleteCertification(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    template
    poster
    fields
    emailTemplateID
    __typename
  }
}
`;
export const createClientAi = /* GraphQL */ `mutation CreateClientAi(
  $input: CreateClientAiInput!
  $condition: ModelClientAiConditionInput
) {
  createClientAi(input: $input, condition: $condition) {
    id
    organizationID
    libraries
    createdAt
    updatedAt
    externalID
    name
    headline
    active
    referrers
    initialState
    portalKey
    page
    searchPortalKey
    searchPage
    inlinePortalKey
    inlinePage
    aiSearchButtonConfig
    buttonConfig
    popupConfig
    mobilePopupConfig
    minimizedConfig
    customInitCode
    customCartUpdateCode
    customProductDescriptionSanitizerCode
    autoOpenConfig
    inlineWidgetWidth
    inlineMinHeight
    inlineMaxHeight
    initialHeight
    autoMinimizeOnBlur
    searchOverrides
    disableConversationPersistence
    platform
    __typename
  }
}
`;
export const updateClientAi = /* GraphQL */ `mutation UpdateClientAi(
  $input: UpdateClientAiInput!
  $condition: ModelClientAiConditionInput
) {
  updateClientAi(input: $input, condition: $condition) {
    id
    organizationID
    libraries
    createdAt
    updatedAt
    externalID
    name
    headline
    active
    referrers
    initialState
    portalKey
    page
    searchPortalKey
    searchPage
    inlinePortalKey
    inlinePage
    aiSearchButtonConfig
    buttonConfig
    popupConfig
    mobilePopupConfig
    minimizedConfig
    customInitCode
    customCartUpdateCode
    customProductDescriptionSanitizerCode
    autoOpenConfig
    inlineWidgetWidth
    inlineMinHeight
    inlineMaxHeight
    initialHeight
    autoMinimizeOnBlur
    searchOverrides
    disableConversationPersistence
    platform
    __typename
  }
}
`;
export const deleteClientAi = /* GraphQL */ `mutation DeleteClientAi(
  $input: DeleteClientAiInput!
  $condition: ModelClientAiConditionInput
) {
  deleteClientAi(input: $input, condition: $condition) {
    id
    organizationID
    libraries
    createdAt
    updatedAt
    externalID
    name
    headline
    active
    referrers
    initialState
    portalKey
    page
    searchPortalKey
    searchPage
    inlinePortalKey
    inlinePage
    aiSearchButtonConfig
    buttonConfig
    popupConfig
    mobilePopupConfig
    minimizedConfig
    customInitCode
    customCartUpdateCode
    customProductDescriptionSanitizerCode
    autoOpenConfig
    inlineWidgetWidth
    inlineMinHeight
    inlineMaxHeight
    initialHeight
    autoMinimizeOnBlur
    searchOverrides
    disableConversationPersistence
    platform
    __typename
  }
}
`;
export const createCourse = /* GraphQL */ `mutation CreateCourse(
  $input: CreateCourseInput!
  $condition: ModelCourseConditionInput
) {
  createCourse(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    format
    libraries
    createdAt
    updatedAt
    externalID
    name
    active
    headline
    description
    objectives
    tags
    keywords
    level
    length
    courseImage
    courseImageThumbnail
    promoVideo
    posterImage
    sharePassword
    audience
    requiredSkills
    gated
    confirmationMessage
    welcomeMessage
    congratulatoryMessage
    startDate
    expiryDate
    searchable
    sections
    reviews
    currency
    discountPercent
    avgRating
    reviewsCount
    courseLessons
    price
    sellPrice
    certification
    companyName
    enrollmentCount
    lessonCount
    faqs
    instructors
    searchInstructors
    ctaUrl
    ctaLabel
    ctaNewWindow
    accessConfiguration
    accessGroups
    excludeFromAllCourses
    portalKicker
    prerequisiteMessage
    prerequisiteCertificates
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    enrollmentOffered
    aiWizardContent
    discussionTopic
    doNotIndex
    doNotReference
    ogImage
    enableAutoplay
    __typename
  }
}
`;
export const updateCourse = /* GraphQL */ `mutation UpdateCourse(
  $input: UpdateCourseInput!
  $condition: ModelCourseConditionInput
) {
  updateCourse(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    format
    libraries
    createdAt
    updatedAt
    externalID
    name
    active
    headline
    description
    objectives
    tags
    keywords
    level
    length
    courseImage
    courseImageThumbnail
    promoVideo
    posterImage
    sharePassword
    audience
    requiredSkills
    gated
    confirmationMessage
    welcomeMessage
    congratulatoryMessage
    startDate
    expiryDate
    searchable
    sections
    reviews
    currency
    discountPercent
    avgRating
    reviewsCount
    courseLessons
    price
    sellPrice
    certification
    companyName
    enrollmentCount
    lessonCount
    faqs
    instructors
    searchInstructors
    ctaUrl
    ctaLabel
    ctaNewWindow
    accessConfiguration
    accessGroups
    excludeFromAllCourses
    portalKicker
    prerequisiteMessage
    prerequisiteCertificates
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    enrollmentOffered
    aiWizardContent
    discussionTopic
    doNotIndex
    doNotReference
    ogImage
    enableAutoplay
    __typename
  }
}
`;
export const deleteCourse = /* GraphQL */ `mutation DeleteCourse(
  $input: DeleteCourseInput!
  $condition: ModelCourseConditionInput
) {
  deleteCourse(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    format
    libraries
    createdAt
    updatedAt
    externalID
    name
    active
    headline
    description
    objectives
    tags
    keywords
    level
    length
    courseImage
    courseImageThumbnail
    promoVideo
    posterImage
    sharePassword
    audience
    requiredSkills
    gated
    confirmationMessage
    welcomeMessage
    congratulatoryMessage
    startDate
    expiryDate
    searchable
    sections
    reviews
    currency
    discountPercent
    avgRating
    reviewsCount
    courseLessons
    price
    sellPrice
    certification
    companyName
    enrollmentCount
    lessonCount
    faqs
    instructors
    searchInstructors
    ctaUrl
    ctaLabel
    ctaNewWindow
    accessConfiguration
    accessGroups
    excludeFromAllCourses
    portalKicker
    prerequisiteMessage
    prerequisiteCertificates
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    enrollmentOffered
    aiWizardContent
    discussionTopic
    doNotIndex
    doNotReference
    ogImage
    enableAutoplay
    __typename
  }
}
`;
export const createCourseProgress = /* GraphQL */ `mutation CreateCourseProgress(
  $input: CreateCourseProgressInput!
  $condition: ModelCourseProgressConditionInput
) {
  createCourseProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    courseID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    lessonProgress
    lessonsCompleted
    quizResults
    notes
    hasCertification
    certificateAwarded
    certificates
    certifications
    completedCertifications
    certificateStatus
    certificateScore
    certificateAwardedAt
    scormData
    tracking
    __typename
  }
}
`;
export const updateCourseProgress = /* GraphQL */ `mutation UpdateCourseProgress(
  $input: UpdateCourseProgressInput!
  $condition: ModelCourseProgressConditionInput
) {
  updateCourseProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    courseID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    lessonProgress
    lessonsCompleted
    quizResults
    notes
    hasCertification
    certificateAwarded
    certificates
    certifications
    completedCertifications
    certificateStatus
    certificateScore
    certificateAwardedAt
    scormData
    tracking
    __typename
  }
}
`;
export const deleteCourseProgress = /* GraphQL */ `mutation DeleteCourseProgress(
  $input: DeleteCourseProgressInput!
  $condition: ModelCourseProgressConditionInput
) {
  deleteCourseProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    courseID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    lessonProgress
    lessonsCompleted
    quizResults
    notes
    hasCertification
    certificateAwarded
    certificates
    certifications
    completedCertifications
    certificateStatus
    certificateScore
    certificateAwardedAt
    scormData
    tracking
    __typename
  }
}
`;
export const createDiscussionTopic = /* GraphQL */ `mutation CreateDiscussionTopic(
  $input: CreateDiscussionTopicInput!
  $condition: ModelDiscussionTopicConditionInput
) {
  createDiscussionTopic(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    approvalRequired
    oneOnOne
    __typename
  }
}
`;
export const updateDiscussionTopic = /* GraphQL */ `mutation UpdateDiscussionTopic(
  $input: UpdateDiscussionTopicInput!
  $condition: ModelDiscussionTopicConditionInput
) {
  updateDiscussionTopic(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    approvalRequired
    oneOnOne
    __typename
  }
}
`;
export const deleteDiscussionTopic = /* GraphQL */ `mutation DeleteDiscussionTopic(
  $input: DeleteDiscussionTopicInput!
  $condition: ModelDiscussionTopicConditionInput
) {
  deleteDiscussionTopic(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    approvalRequired
    oneOnOne
    __typename
  }
}
`;
export const createDiscussionPost = /* GraphQL */ `mutation CreateDiscussionPost(
  $input: CreateDiscussionPostInput!
  $condition: ModelDiscussionPostConditionInput
) {
  createDiscussionPost(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    userID
    approvedByID
    repliesTo
    createdAt
    updatedAt
    topicID
    name
    content
    attachment
    status
    __typename
  }
}
`;
export const updateDiscussionPost = /* GraphQL */ `mutation UpdateDiscussionPost(
  $input: UpdateDiscussionPostInput!
  $condition: ModelDiscussionPostConditionInput
) {
  updateDiscussionPost(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    userID
    approvedByID
    repliesTo
    createdAt
    updatedAt
    topicID
    name
    content
    attachment
    status
    __typename
  }
}
`;
export const deleteDiscussionPost = /* GraphQL */ `mutation DeleteDiscussionPost(
  $input: DeleteDiscussionPostInput!
  $condition: ModelDiscussionPostConditionInput
) {
  deleteDiscussionPost(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    userID
    approvedByID
    repliesTo
    createdAt
    updatedAt
    topicID
    name
    content
    attachment
    status
    __typename
  }
}
`;
export const createCustomer = /* GraphQL */ `mutation CreateCustomer(
  $input: CreateCustomerInput!
  $condition: ModelCustomerConditionInput
) {
  createCustomer(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    phoneNumber
    biography
    profileImage
    email
    temporaryPassword
    background
    headline
    internalNotes
    title
    hubID
    stripeCustomerID
    activeMembershipCount
    trialMembershipCount
    overdueMembershipCount
    expiredMembershipCount
    lastPaymentAt
    nextPaymentAt
    text1
    text2
    text3
    text4
    text5
    status
    learningBoards {
      nextToken
      __typename
    }
    members {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const updateCustomer = /* GraphQL */ `mutation UpdateCustomer(
  $input: UpdateCustomerInput!
  $condition: ModelCustomerConditionInput
) {
  updateCustomer(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    phoneNumber
    biography
    profileImage
    email
    temporaryPassword
    background
    headline
    internalNotes
    title
    hubID
    stripeCustomerID
    activeMembershipCount
    trialMembershipCount
    overdueMembershipCount
    expiredMembershipCount
    lastPaymentAt
    nextPaymentAt
    text1
    text2
    text3
    text4
    text5
    status
    learningBoards {
      nextToken
      __typename
    }
    members {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const deleteCustomer = /* GraphQL */ `mutation DeleteCustomer(
  $input: DeleteCustomerInput!
  $condition: ModelCustomerConditionInput
) {
  deleteCustomer(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    phoneNumber
    biography
    profileImage
    email
    temporaryPassword
    background
    headline
    internalNotes
    title
    hubID
    stripeCustomerID
    activeMembershipCount
    trialMembershipCount
    overdueMembershipCount
    expiredMembershipCount
    lastPaymentAt
    nextPaymentAt
    text1
    text2
    text3
    text4
    text5
    status
    learningBoards {
      nextToken
      __typename
    }
    members {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const createDocument = /* GraphQL */ `mutation CreateDocument(
  $input: CreateDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  createDocument(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    libraries
    createdAt
    updatedAt
    name
    publishedAt
    active
    headline
    description
    image
    asset
    content
    tags
    keywords
    level
    instructors
    searchInstructors
    searchable
    ctaUrl
    ctaLabel
    ctaNewWindow
    excludeFromAllCourses
    accessConfiguration
    accessGroups
    portalKicker
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    ogImage
    doNotIndex
    doNotReference
    __typename
  }
}
`;
export const updateDocument = /* GraphQL */ `mutation UpdateDocument(
  $input: UpdateDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  updateDocument(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    libraries
    createdAt
    updatedAt
    name
    publishedAt
    active
    headline
    description
    image
    asset
    content
    tags
    keywords
    level
    instructors
    searchInstructors
    searchable
    ctaUrl
    ctaLabel
    ctaNewWindow
    excludeFromAllCourses
    accessConfiguration
    accessGroups
    portalKicker
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    ogImage
    doNotIndex
    doNotReference
    __typename
  }
}
`;
export const deleteDocument = /* GraphQL */ `mutation DeleteDocument(
  $input: DeleteDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  deleteDocument(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    libraries
    createdAt
    updatedAt
    name
    publishedAt
    active
    headline
    description
    image
    asset
    content
    tags
    keywords
    level
    instructors
    searchInstructors
    searchable
    ctaUrl
    ctaLabel
    ctaNewWindow
    excludeFromAllCourses
    accessConfiguration
    accessGroups
    portalKicker
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    ogImage
    doNotIndex
    doNotReference
    __typename
  }
}
`;
export const createDocumentProgress = /* GraphQL */ `mutation CreateDocumentProgress(
  $input: CreateDocumentProgressInput!
  $condition: ModelDocumentProgressConditionInput
) {
  createDocumentProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    documentKey
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    notes
    status
    viewCount
    history
    includeInMyDocuments
    __typename
  }
}
`;
export const updateDocumentProgress = /* GraphQL */ `mutation UpdateDocumentProgress(
  $input: UpdateDocumentProgressInput!
  $condition: ModelDocumentProgressConditionInput
) {
  updateDocumentProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    documentKey
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    notes
    status
    viewCount
    history
    includeInMyDocuments
    __typename
  }
}
`;
export const deleteDocumentProgress = /* GraphQL */ `mutation DeleteDocumentProgress(
  $input: DeleteDocumentProgressInput!
  $condition: ModelDocumentProgressConditionInput
) {
  deleteDocumentProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    documentKey
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    notes
    status
    viewCount
    history
    includeInMyDocuments
    __typename
  }
}
`;
export const createEmailTemplate = /* GraphQL */ `mutation CreateEmailTemplate(
  $input: CreateEmailTemplateInput!
  $condition: ModelEmailTemplateConditionInput
) {
  createEmailTemplate(input: $input, condition: $condition) {
    id
    organizationID
    name
    from
    bcc
    subject
    tags
    body
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateEmailTemplate = /* GraphQL */ `mutation UpdateEmailTemplate(
  $input: UpdateEmailTemplateInput!
  $condition: ModelEmailTemplateConditionInput
) {
  updateEmailTemplate(input: $input, condition: $condition) {
    id
    organizationID
    name
    from
    bcc
    subject
    tags
    body
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteEmailTemplate = /* GraphQL */ `mutation DeleteEmailTemplate(
  $input: DeleteEmailTemplateInput!
  $condition: ModelEmailTemplateConditionInput
) {
  deleteEmailTemplate(input: $input, condition: $condition) {
    id
    organizationID
    name
    from
    bcc
    subject
    tags
    body
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createEngagementHistory = /* GraphQL */ `mutation CreateEngagementHistory(
  $input: CreateEngagementHistoryInput!
  $condition: ModelEngagementHistoryConditionInput
) {
  createEngagementHistory(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    flowID
    itemID
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateEngagementHistory = /* GraphQL */ `mutation UpdateEngagementHistory(
  $input: UpdateEngagementHistoryInput!
  $condition: ModelEngagementHistoryConditionInput
) {
  updateEngagementHistory(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    flowID
    itemID
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteEngagementHistory = /* GraphQL */ `mutation DeleteEngagementHistory(
  $input: DeleteEngagementHistoryInput!
  $condition: ModelEngagementHistoryConditionInput
) {
  deleteEngagementHistory(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    flowID
    itemID
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createEngagementFlow = /* GraphQL */ `mutation CreateEngagementFlow(
  $input: CreateEngagementFlowInput!
  $condition: ModelEngagementFlowConditionInput
) {
  createEngagementFlow(input: $input, condition: $condition) {
    id
    organizationID
    name
    description
    active
    tags
    flow
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateEngagementFlow = /* GraphQL */ `mutation UpdateEngagementFlow(
  $input: UpdateEngagementFlowInput!
  $condition: ModelEngagementFlowConditionInput
) {
  updateEngagementFlow(input: $input, condition: $condition) {
    id
    organizationID
    name
    description
    active
    tags
    flow
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteEngagementFlow = /* GraphQL */ `mutation DeleteEngagementFlow(
  $input: DeleteEngagementFlowInput!
  $condition: ModelEngagementFlowConditionInput
) {
  deleteEngagementFlow(input: $input, condition: $condition) {
    id
    organizationID
    name
    description
    active
    tags
    flow
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createHub = /* GraphQL */ `mutation CreateHub(
  $input: CreateHubInput!
  $condition: ModelHubConditionInput
) {
  createHub(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    defaultLibraryID
    createdAt
    updatedAt
    name
    active
    description
    logoImage
    categories
    learningBoards {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const updateHub = /* GraphQL */ `mutation UpdateHub(
  $input: UpdateHubInput!
  $condition: ModelHubConditionInput
) {
  updateHub(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    defaultLibraryID
    createdAt
    updatedAt
    name
    active
    description
    logoImage
    categories
    learningBoards {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const deleteHub = /* GraphQL */ `mutation DeleteHub(
  $input: DeleteHubInput!
  $condition: ModelHubConditionInput
) {
  deleteHub(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    defaultLibraryID
    createdAt
    updatedAt
    name
    active
    description
    logoImage
    categories
    learningBoards {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const createInstructor = /* GraphQL */ `mutation CreateInstructor(
  $input: CreateInstructorInput!
  $condition: ModelInstructorConditionInput
) {
  createInstructor(input: $input, condition: $condition) {
    id
    organizationID
    slug
    userID
    createdAt
    updatedAt
    name
    title
    byline
    aiVisibilityAuthority
    bylineRole
    sortOrder
    biography
    profileImage
    email
    linkedInUrl
    twitterUrl
    facebookUrl
    instagramUrl
    youtubeUrl
    shopifyBioArticleId
    shopifyBioUrl
    __typename
  }
}
`;
export const updateInstructor = /* GraphQL */ `mutation UpdateInstructor(
  $input: UpdateInstructorInput!
  $condition: ModelInstructorConditionInput
) {
  updateInstructor(input: $input, condition: $condition) {
    id
    organizationID
    slug
    userID
    createdAt
    updatedAt
    name
    title
    byline
    aiVisibilityAuthority
    bylineRole
    sortOrder
    biography
    profileImage
    email
    linkedInUrl
    twitterUrl
    facebookUrl
    instagramUrl
    youtubeUrl
    shopifyBioArticleId
    shopifyBioUrl
    __typename
  }
}
`;
export const deleteInstructor = /* GraphQL */ `mutation DeleteInstructor(
  $input: DeleteInstructorInput!
  $condition: ModelInstructorConditionInput
) {
  deleteInstructor(input: $input, condition: $condition) {
    id
    organizationID
    slug
    userID
    createdAt
    updatedAt
    name
    title
    byline
    aiVisibilityAuthority
    bylineRole
    sortOrder
    biography
    profileImage
    email
    linkedInUrl
    twitterUrl
    facebookUrl
    instagramUrl
    youtubeUrl
    shopifyBioArticleId
    shopifyBioUrl
    __typename
  }
}
`;
export const createInvite = /* GraphQL */ `mutation CreateInvite(
  $input: CreateInviteInput!
  $condition: ModelInviteConditionInput
) {
  createInvite(input: $input, condition: $condition) {
    id
    organizationID
    inviteeEmail
    invitedBy
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateInvite = /* GraphQL */ `mutation UpdateInvite(
  $input: UpdateInviteInput!
  $condition: ModelInviteConditionInput
) {
  updateInvite(input: $input, condition: $condition) {
    id
    organizationID
    inviteeEmail
    invitedBy
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteInvite = /* GraphQL */ `mutation DeleteInvite(
  $input: DeleteInviteInput!
  $condition: ModelInviteConditionInput
) {
  deleteInvite(input: $input, condition: $condition) {
    id
    organizationID
    inviteeEmail
    invitedBy
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createProfile = /* GraphQL */ `mutation CreateProfile(
  $input: CreateProfileInput!
  $condition: ModelProfileConditionInput
) {
  createProfile(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    conversationID
    userID
    email
    capturedData
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateProfile = /* GraphQL */ `mutation UpdateProfile(
  $input: UpdateProfileInput!
  $condition: ModelProfileConditionInput
) {
  updateProfile(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    conversationID
    userID
    email
    capturedData
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteProfile = /* GraphQL */ `mutation DeleteProfile(
  $input: DeleteProfileInput!
  $condition: ModelProfileConditionInput
) {
  deleteProfile(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    conversationID
    userID
    email
    capturedData
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createLead = /* GraphQL */ `mutation CreateLead(
  $input: CreateLeadInput!
  $condition: ModelLeadConditionInput
) {
  createLead(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    email
    firstName
    lastName
    company
    phoneNumber
    __typename
  }
}
`;
export const updateLead = /* GraphQL */ `mutation UpdateLead(
  $input: UpdateLeadInput!
  $condition: ModelLeadConditionInput
) {
  updateLead(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    email
    firstName
    lastName
    company
    phoneNumber
    __typename
  }
}
`;
export const deleteLead = /* GraphQL */ `mutation DeleteLead(
  $input: DeleteLeadInput!
  $condition: ModelLeadConditionInput
) {
  deleteLead(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    email
    firstName
    lastName
    company
    phoneNumber
    __typename
  }
}
`;
export const createLearningBoard = /* GraphQL */ `mutation CreateLearningBoard(
  $input: CreateLearningBoardInput!
  $condition: ModelLearningBoardConditionInput
) {
  createLearningBoard(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    customerID
    createdAt
    updatedAt
    name
    status
    sections
    learningBoardViewedAt
    __typename
  }
}
`;
export const updateLearningBoard = /* GraphQL */ `mutation UpdateLearningBoard(
  $input: UpdateLearningBoardInput!
  $condition: ModelLearningBoardConditionInput
) {
  updateLearningBoard(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    customerID
    createdAt
    updatedAt
    name
    status
    sections
    learningBoardViewedAt
    __typename
  }
}
`;
export const deleteLearningBoard = /* GraphQL */ `mutation DeleteLearningBoard(
  $input: DeleteLearningBoardInput!
  $condition: ModelLearningBoardConditionInput
) {
  deleteLearningBoard(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    customerID
    createdAt
    updatedAt
    name
    status
    sections
    learningBoardViewedAt
    __typename
  }
}
`;
export const createLibrary = /* GraphQL */ `mutation CreateLibrary(
  $input: CreateLibraryInput!
  $condition: ModelLibraryConditionInput
) {
  createLibrary(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    status
    __typename
  }
}
`;
export const updateLibrary = /* GraphQL */ `mutation UpdateLibrary(
  $input: UpdateLibraryInput!
  $condition: ModelLibraryConditionInput
) {
  updateLibrary(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    status
    __typename
  }
}
`;
export const deleteLibrary = /* GraphQL */ `mutation DeleteLibrary(
  $input: DeleteLibraryInput!
  $condition: ModelLibraryConditionInput
) {
  deleteLibrary(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    status
    __typename
  }
}
`;
export const createLibraryShare = /* GraphQL */ `mutation CreateLibraryShare(
  $input: CreateLibraryShareInput!
  $condition: ModelLibraryShareConditionInput
) {
  createLibraryShare(input: $input, condition: $condition) {
    id
    organizationID
    targetOrganizationID
    libraryID
    createdAt
    updatedAt
    name
    status
    __typename
  }
}
`;
export const updateLibraryShare = /* GraphQL */ `mutation UpdateLibraryShare(
  $input: UpdateLibraryShareInput!
  $condition: ModelLibraryShareConditionInput
) {
  updateLibraryShare(input: $input, condition: $condition) {
    id
    organizationID
    targetOrganizationID
    libraryID
    createdAt
    updatedAt
    name
    status
    __typename
  }
}
`;
export const deleteLibraryShare = /* GraphQL */ `mutation DeleteLibraryShare(
  $input: DeleteLibraryShareInput!
  $condition: ModelLibraryShareConditionInput
) {
  deleteLibraryShare(input: $input, condition: $condition) {
    id
    organizationID
    targetOrganizationID
    libraryID
    createdAt
    updatedAt
    name
    status
    __typename
  }
}
`;
export const createMeeting = /* GraphQL */ `mutation CreateMeeting(
  $input: CreateMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  createMeeting(input: $input, condition: $condition) {
    id
    organizationID
    slug
    libraries
    portalID
    meetingType
    status
    createdAt
    createdByID
    updatedAt
    name
    headline
    description
    content
    instructors
    searchInstructors
    transcript
    image
    recordingID
    recordingMediaPipelineID
    preStartOpenDuration
    startsAt
    postStartGraceDuration
    plannedDuration
    actualDuration
    chimeMeeting {
      ExternalMeetingId
      MediaRegion
      MeetingArn
      MeetingId
      TenantIds
      __typename
    }
    preMeetingMessage
    postMeetingMessage
    mediaRegion
    registrationRequired
    registerBy
    restrictByAccessGroup
    accessGroups
    restrictByCustomer
    customers
    registrationCount
    registrationMax
    portalKicker
    attendees
    __typename
  }
}
`;
export const updateMeeting = /* GraphQL */ `mutation UpdateMeeting(
  $input: UpdateMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  updateMeeting(input: $input, condition: $condition) {
    id
    organizationID
    slug
    libraries
    portalID
    meetingType
    status
    createdAt
    createdByID
    updatedAt
    name
    headline
    description
    content
    instructors
    searchInstructors
    transcript
    image
    recordingID
    recordingMediaPipelineID
    preStartOpenDuration
    startsAt
    postStartGraceDuration
    plannedDuration
    actualDuration
    chimeMeeting {
      ExternalMeetingId
      MediaRegion
      MeetingArn
      MeetingId
      TenantIds
      __typename
    }
    preMeetingMessage
    postMeetingMessage
    mediaRegion
    registrationRequired
    registerBy
    restrictByAccessGroup
    accessGroups
    restrictByCustomer
    customers
    registrationCount
    registrationMax
    portalKicker
    attendees
    __typename
  }
}
`;
export const deleteMeeting = /* GraphQL */ `mutation DeleteMeeting(
  $input: DeleteMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  deleteMeeting(input: $input, condition: $condition) {
    id
    organizationID
    slug
    libraries
    portalID
    meetingType
    status
    createdAt
    createdByID
    updatedAt
    name
    headline
    description
    content
    instructors
    searchInstructors
    transcript
    image
    recordingID
    recordingMediaPipelineID
    preStartOpenDuration
    startsAt
    postStartGraceDuration
    plannedDuration
    actualDuration
    chimeMeeting {
      ExternalMeetingId
      MediaRegion
      MeetingArn
      MeetingId
      TenantIds
      __typename
    }
    preMeetingMessage
    postMeetingMessage
    mediaRegion
    registrationRequired
    registerBy
    restrictByAccessGroup
    accessGroups
    restrictByCustomer
    customers
    registrationCount
    registrationMax
    portalKicker
    attendees
    __typename
  }
}
`;
export const createMeetingRegistration = /* GraphQL */ `mutation CreateMeetingRegistration(
  $input: CreateMeetingRegistrationInput!
  $condition: ModelMeetingRegistrationConditionInput
) {
  createMeetingRegistration(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    customerID
    meetingID
    name
    status
    createdAt
    updatedAt
    notes
    history
    __typename
  }
}
`;
export const updateMeetingRegistration = /* GraphQL */ `mutation UpdateMeetingRegistration(
  $input: UpdateMeetingRegistrationInput!
  $condition: ModelMeetingRegistrationConditionInput
) {
  updateMeetingRegistration(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    customerID
    meetingID
    name
    status
    createdAt
    updatedAt
    notes
    history
    __typename
  }
}
`;
export const deleteMeetingRegistration = /* GraphQL */ `mutation DeleteMeetingRegistration(
  $input: DeleteMeetingRegistrationInput!
  $condition: ModelMeetingRegistrationConditionInput
) {
  deleteMeetingRegistration(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    customerID
    meetingID
    name
    status
    createdAt
    updatedAt
    notes
    history
    __typename
  }
}
`;
export const createMember = /* GraphQL */ `mutation CreateMember(
  $input: CreateMemberInput!
  $condition: ModelMemberConditionInput
) {
  createMember(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    portalID
    membershipID
    name
    status
    createdAt
    updatedAt
    expiresOn
    lastPaymentAt
    nextPaymentAt
    failedPaymentAttempts
    stripeSessionID
    stripePaymentIntentID
    stripeSubscriptionID
    stripeCustomerID
    stripeInvoiceID
    stripeExpiresAt
    __typename
  }
}
`;
export const updateMember = /* GraphQL */ `mutation UpdateMember(
  $input: UpdateMemberInput!
  $condition: ModelMemberConditionInput
) {
  updateMember(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    portalID
    membershipID
    name
    status
    createdAt
    updatedAt
    expiresOn
    lastPaymentAt
    nextPaymentAt
    failedPaymentAttempts
    stripeSessionID
    stripePaymentIntentID
    stripeSubscriptionID
    stripeCustomerID
    stripeInvoiceID
    stripeExpiresAt
    __typename
  }
}
`;
export const deleteMember = /* GraphQL */ `mutation DeleteMember(
  $input: DeleteMemberInput!
  $condition: ModelMemberConditionInput
) {
  deleteMember(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    portalID
    membershipID
    name
    status
    createdAt
    updatedAt
    expiresOn
    lastPaymentAt
    nextPaymentAt
    failedPaymentAttempts
    stripeSessionID
    stripePaymentIntentID
    stripeSubscriptionID
    stripeCustomerID
    stripeInvoiceID
    stripeExpiresAt
    __typename
  }
}
`;
export const createMembership = /* GraphQL */ `mutation CreateMembership(
  $input: CreateMembershipInput!
  $condition: ModelMembershipConditionInput
) {
  createMembership(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    type
    typeID
    createdAt
    updatedAt
    name
    maxMembers
    activeMembers
    description
    active
    startDate
    endDate
    paymentPlan
    recurringPrice
    recurringTerm
    installmentPrice
    installmentCount
    installmentRecurrence
    onetimePrice
    onetimeEnableExpiry
    onetimeExpireDays
    installmentEnableExpiry
    installmentExpireDays
    trialEnabled
    trialDays
    taxExempt
    courses
    categories
    accessGroups
    confirmationMessage
    orderConfirmationEmailID
    upgradeMembershipID
    downgradeMembershipID
    emailAllowedDomains
    emailDomainMismatchError
    __typename
  }
}
`;
export const updateMembership = /* GraphQL */ `mutation UpdateMembership(
  $input: UpdateMembershipInput!
  $condition: ModelMembershipConditionInput
) {
  updateMembership(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    type
    typeID
    createdAt
    updatedAt
    name
    maxMembers
    activeMembers
    description
    active
    startDate
    endDate
    paymentPlan
    recurringPrice
    recurringTerm
    installmentPrice
    installmentCount
    installmentRecurrence
    onetimePrice
    onetimeEnableExpiry
    onetimeExpireDays
    installmentEnableExpiry
    installmentExpireDays
    trialEnabled
    trialDays
    taxExempt
    courses
    categories
    accessGroups
    confirmationMessage
    orderConfirmationEmailID
    upgradeMembershipID
    downgradeMembershipID
    emailAllowedDomains
    emailDomainMismatchError
    __typename
  }
}
`;
export const deleteMembership = /* GraphQL */ `mutation DeleteMembership(
  $input: DeleteMembershipInput!
  $condition: ModelMembershipConditionInput
) {
  deleteMembership(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    type
    typeID
    createdAt
    updatedAt
    name
    maxMembers
    activeMembers
    description
    active
    startDate
    endDate
    paymentPlan
    recurringPrice
    recurringTerm
    installmentPrice
    installmentCount
    installmentRecurrence
    onetimePrice
    onetimeEnableExpiry
    onetimeExpireDays
    installmentEnableExpiry
    installmentExpireDays
    trialEnabled
    trialDays
    taxExempt
    courses
    categories
    accessGroups
    confirmationMessage
    orderConfirmationEmailID
    upgradeMembershipID
    downgradeMembershipID
    emailAllowedDomains
    emailDomainMismatchError
    __typename
  }
}
`;
export const createMicrocast = /* GraphQL */ `mutation CreateMicrocast(
  $input: CreateMicrocastInput!
  $condition: ModelMicrocastConditionInput
) {
  createMicrocast(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    format
    libraries
    createdAt
    updatedAt
    name
    active
    headline
    description
    microcastImage
    useAsPoster
    microcastAsset
    scormAsset
    posterImage
    content
    tags
    keywords
    level
    instructors
    searchInstructors
    searchable
    ctaUrl
    ctaLabel
    ctaNewWindow
    excludeFromAllCourses
    accessConfiguration
    accessGroups
    portalKicker
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    disableSeekAhead
    ogImage
    doNotIndex
    doNotReference
    __typename
  }
}
`;
export const updateMicrocast = /* GraphQL */ `mutation UpdateMicrocast(
  $input: UpdateMicrocastInput!
  $condition: ModelMicrocastConditionInput
) {
  updateMicrocast(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    format
    libraries
    createdAt
    updatedAt
    name
    active
    headline
    description
    microcastImage
    useAsPoster
    microcastAsset
    scormAsset
    posterImage
    content
    tags
    keywords
    level
    instructors
    searchInstructors
    searchable
    ctaUrl
    ctaLabel
    ctaNewWindow
    excludeFromAllCourses
    accessConfiguration
    accessGroups
    portalKicker
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    disableSeekAhead
    ogImage
    doNotIndex
    doNotReference
    __typename
  }
}
`;
export const deleteMicrocast = /* GraphQL */ `mutation DeleteMicrocast(
  $input: DeleteMicrocastInput!
  $condition: ModelMicrocastConditionInput
) {
  deleteMicrocast(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    format
    libraries
    createdAt
    updatedAt
    name
    active
    headline
    description
    microcastImage
    useAsPoster
    microcastAsset
    scormAsset
    posterImage
    content
    tags
    keywords
    level
    instructors
    searchInstructors
    searchable
    ctaUrl
    ctaLabel
    ctaNewWindow
    excludeFromAllCourses
    accessConfiguration
    accessGroups
    portalKicker
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    disableSeekAhead
    ogImage
    doNotIndex
    doNotReference
    __typename
  }
}
`;
export const createMicrocastProgress = /* GraphQL */ `mutation CreateMicrocastProgress(
  $input: CreateMicrocastProgressInput!
  $condition: ModelMicrocastProgressConditionInput
) {
  createMicrocastProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    microcastID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    notes
    scormData
    lastPosition
    maxPosition
    tracking
    __typename
  }
}
`;
export const updateMicrocastProgress = /* GraphQL */ `mutation UpdateMicrocastProgress(
  $input: UpdateMicrocastProgressInput!
  $condition: ModelMicrocastProgressConditionInput
) {
  updateMicrocastProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    microcastID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    notes
    scormData
    lastPosition
    maxPosition
    tracking
    __typename
  }
}
`;
export const deleteMicrocastProgress = /* GraphQL */ `mutation DeleteMicrocastProgress(
  $input: DeleteMicrocastProgressInput!
  $condition: ModelMicrocastProgressConditionInput
) {
  deleteMicrocastProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    microcastID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    notes
    scormData
    lastPosition
    maxPosition
    tracking
    __typename
  }
}
`;
export const createOrganization = /* GraphQL */ `mutation CreateOrganization(
  $input: CreateOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  createOrganization(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    stripePublicKey
    stripeSecretKey
    googleApiConfig
    googleApiSyncInfo
    cognitoUserPoolID
    cognitoWebClientID
    cognitoIdentityPoolID
    signUpFields
    signUpRequiredFields
    appsyncGraphqlID
    appsyncGraphqlKey
    appsyncGraphqlUrl
    deployedAt
    deployStatus
    Courses {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      externalID
      name
      active
      headline
      description
      objectives
      tags
      keywords
      level
      length
      courseImage
      courseImageThumbnail
      promoVideo
      posterImage
      sharePassword
      audience
      requiredSkills
      gated
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      startDate
      expiryDate
      searchable
      sections
      reviews
      currency
      discountPercent
      avgRating
      reviewsCount
      courseLessons
      price
      sellPrice
      certification
      companyName
      enrollmentCount
      lessonCount
      faqs
      instructors
      searchInstructors
      ctaUrl
      ctaLabel
      ctaNewWindow
      accessConfiguration
      accessGroups
      excludeFromAllCourses
      portalKicker
      prerequisiteMessage
      prerequisiteCertificates
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      enrollmentOffered
      aiWizardContent
      discussionTopic
      doNotIndex
      doNotReference
      ogImage
      enableAutoplay
      __typename
    }
    Portals {
      id
      organizationID
      defaultLibraryID
      libraries
      libraryShares
      createdAt
      updatedAt
      name
      active
      publicName
      publicDomain
      sslDomain
      description
      type
      allowSearch
      enableInstructors
      requireSignature
      logoImage
      faviconImage
      ogImage
      categories
      pageDefaults
      pageRules
      componentConfigs
      termsOfService
      cardShowPrice
      publicCardShowActionButton
      publicCardButtonLabel
      publicCardAction
      publicLandingPageButtonLabel
      membershipCardShowActionButton
      membershipCardWithAccessButtonLabel
      membershipCardWithAccessAction
      membershipCardNoAccessButtonLabel
      membershipCardNoAccessAction
      membershipLandingPageWithAccessButtonLabel
      membershipLandingPageNoAccessButtonLabel
      membershipLandingPageNoAccessMembershipAction
      commerceCardShowActionButton
      commerceCardNoAccessButtonLabel
      commerceCardNoAccessAction
      commerceCardWithAccessButtonLabel
      commerceCardWithAccessAction
      commerceLandingPageWithAccessButtonLabel
      commerceLandingPageNoAccessButtonLabel
      commerceLandingPageNoAccessAction
      primaryMembershipID
      membershipOfferPageID
      noAccessImage
      learningBoardGroupNames
      stylesheet
      tokens
      supportedLocales
      defaultCheckoutConfirmationMessage
      courseCardShowImage
      courseCardShowTitle
      courseCardShowInstructor
      courseCardShowDesc
      courseCardShowInfoBar
      courseCardShowActionButton
      courseCardShowLessonCount
      showCertification
      orderConfirmationEmailID
      newCustomerMembershipID
      showLearningBoard
      showUserNameInLearningBoard
      trackDeskTenantId
      cloudfrontDistributionID
      cloudfrontDistributionDomain
      deployedAt
      deployStatus
      googleAnalyticsTagID
      programLandingWithAccessCourseAction
      footerScripts
      repositoryOriginAccessIdentityID
      clientAIAnswerLength
      clientAIFeedbackButtons
      clientAIPromptPlaceholder
      clientAISuggestedPrompts
      clientAIPersistentPrompts
      clientAIPromptTemplate
      clientAIStartingMessage
      clientAIInlineReferences
      clientAISuggestRefinements
      clientAIAdditionalInstructions
      clientAIConfig
      learningBoardConfig
      addToCartEnabled
      productCardConfig
      aiSearchConfig
      clientAIBaseUrl
      showQuizResultsTab
      status
      purgeStatus
      purgeSteps
      purgeError
      __typename
    }
    accessGroups
    enableDiscussionGroups
    enableAI
    defaultRoles
    enableMeetings
    enableHubs
    enableGeo
    clientAILanguageModel
    contentGenerationModel
    clientAIStatus
    crawlConfigs
    internalIpRanges
    usePostHnswFilter
    exportFullConversations
    syncConfigs
    searchGuidance
    status
    deletedAt
    deletedBy
    purgeScheduledAt
    purgeStatus
    purgeSteps
    purgeError
    clonedFromEnv
    clonedAt
    Users {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const updateOrganization = /* GraphQL */ `mutation UpdateOrganization(
  $input: UpdateOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  updateOrganization(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    stripePublicKey
    stripeSecretKey
    googleApiConfig
    googleApiSyncInfo
    cognitoUserPoolID
    cognitoWebClientID
    cognitoIdentityPoolID
    signUpFields
    signUpRequiredFields
    appsyncGraphqlID
    appsyncGraphqlKey
    appsyncGraphqlUrl
    deployedAt
    deployStatus
    Courses {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      externalID
      name
      active
      headline
      description
      objectives
      tags
      keywords
      level
      length
      courseImage
      courseImageThumbnail
      promoVideo
      posterImage
      sharePassword
      audience
      requiredSkills
      gated
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      startDate
      expiryDate
      searchable
      sections
      reviews
      currency
      discountPercent
      avgRating
      reviewsCount
      courseLessons
      price
      sellPrice
      certification
      companyName
      enrollmentCount
      lessonCount
      faqs
      instructors
      searchInstructors
      ctaUrl
      ctaLabel
      ctaNewWindow
      accessConfiguration
      accessGroups
      excludeFromAllCourses
      portalKicker
      prerequisiteMessage
      prerequisiteCertificates
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      enrollmentOffered
      aiWizardContent
      discussionTopic
      doNotIndex
      doNotReference
      ogImage
      enableAutoplay
      __typename
    }
    Portals {
      id
      organizationID
      defaultLibraryID
      libraries
      libraryShares
      createdAt
      updatedAt
      name
      active
      publicName
      publicDomain
      sslDomain
      description
      type
      allowSearch
      enableInstructors
      requireSignature
      logoImage
      faviconImage
      ogImage
      categories
      pageDefaults
      pageRules
      componentConfigs
      termsOfService
      cardShowPrice
      publicCardShowActionButton
      publicCardButtonLabel
      publicCardAction
      publicLandingPageButtonLabel
      membershipCardShowActionButton
      membershipCardWithAccessButtonLabel
      membershipCardWithAccessAction
      membershipCardNoAccessButtonLabel
      membershipCardNoAccessAction
      membershipLandingPageWithAccessButtonLabel
      membershipLandingPageNoAccessButtonLabel
      membershipLandingPageNoAccessMembershipAction
      commerceCardShowActionButton
      commerceCardNoAccessButtonLabel
      commerceCardNoAccessAction
      commerceCardWithAccessButtonLabel
      commerceCardWithAccessAction
      commerceLandingPageWithAccessButtonLabel
      commerceLandingPageNoAccessButtonLabel
      commerceLandingPageNoAccessAction
      primaryMembershipID
      membershipOfferPageID
      noAccessImage
      learningBoardGroupNames
      stylesheet
      tokens
      supportedLocales
      defaultCheckoutConfirmationMessage
      courseCardShowImage
      courseCardShowTitle
      courseCardShowInstructor
      courseCardShowDesc
      courseCardShowInfoBar
      courseCardShowActionButton
      courseCardShowLessonCount
      showCertification
      orderConfirmationEmailID
      newCustomerMembershipID
      showLearningBoard
      showUserNameInLearningBoard
      trackDeskTenantId
      cloudfrontDistributionID
      cloudfrontDistributionDomain
      deployedAt
      deployStatus
      googleAnalyticsTagID
      programLandingWithAccessCourseAction
      footerScripts
      repositoryOriginAccessIdentityID
      clientAIAnswerLength
      clientAIFeedbackButtons
      clientAIPromptPlaceholder
      clientAISuggestedPrompts
      clientAIPersistentPrompts
      clientAIPromptTemplate
      clientAIStartingMessage
      clientAIInlineReferences
      clientAISuggestRefinements
      clientAIAdditionalInstructions
      clientAIConfig
      learningBoardConfig
      addToCartEnabled
      productCardConfig
      aiSearchConfig
      clientAIBaseUrl
      showQuizResultsTab
      status
      purgeStatus
      purgeSteps
      purgeError
      __typename
    }
    accessGroups
    enableDiscussionGroups
    enableAI
    defaultRoles
    enableMeetings
    enableHubs
    enableGeo
    clientAILanguageModel
    contentGenerationModel
    clientAIStatus
    crawlConfigs
    internalIpRanges
    usePostHnswFilter
    exportFullConversations
    syncConfigs
    searchGuidance
    status
    deletedAt
    deletedBy
    purgeScheduledAt
    purgeStatus
    purgeSteps
    purgeError
    clonedFromEnv
    clonedAt
    Users {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const deleteOrganization = /* GraphQL */ `mutation DeleteOrganization(
  $input: DeleteOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  deleteOrganization(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    stripePublicKey
    stripeSecretKey
    googleApiConfig
    googleApiSyncInfo
    cognitoUserPoolID
    cognitoWebClientID
    cognitoIdentityPoolID
    signUpFields
    signUpRequiredFields
    appsyncGraphqlID
    appsyncGraphqlKey
    appsyncGraphqlUrl
    deployedAt
    deployStatus
    Courses {
      id
      organizationID
      slug
      manualSlug
      format
      libraries
      createdAt
      updatedAt
      externalID
      name
      active
      headline
      description
      objectives
      tags
      keywords
      level
      length
      courseImage
      courseImageThumbnail
      promoVideo
      posterImage
      sharePassword
      audience
      requiredSkills
      gated
      confirmationMessage
      welcomeMessage
      congratulatoryMessage
      startDate
      expiryDate
      searchable
      sections
      reviews
      currency
      discountPercent
      avgRating
      reviewsCount
      courseLessons
      price
      sellPrice
      certification
      companyName
      enrollmentCount
      lessonCount
      faqs
      instructors
      searchInstructors
      ctaUrl
      ctaLabel
      ctaNewWindow
      accessConfiguration
      accessGroups
      excludeFromAllCourses
      portalKicker
      prerequisiteMessage
      prerequisiteCertificates
      richText1
      richText2
      richText3
      richText4
      richText5
      richText6
      richText7
      richText8
      richText9
      richText10
      enrollmentOffered
      aiWizardContent
      discussionTopic
      doNotIndex
      doNotReference
      ogImage
      enableAutoplay
      __typename
    }
    Portals {
      id
      organizationID
      defaultLibraryID
      libraries
      libraryShares
      createdAt
      updatedAt
      name
      active
      publicName
      publicDomain
      sslDomain
      description
      type
      allowSearch
      enableInstructors
      requireSignature
      logoImage
      faviconImage
      ogImage
      categories
      pageDefaults
      pageRules
      componentConfigs
      termsOfService
      cardShowPrice
      publicCardShowActionButton
      publicCardButtonLabel
      publicCardAction
      publicLandingPageButtonLabel
      membershipCardShowActionButton
      membershipCardWithAccessButtonLabel
      membershipCardWithAccessAction
      membershipCardNoAccessButtonLabel
      membershipCardNoAccessAction
      membershipLandingPageWithAccessButtonLabel
      membershipLandingPageNoAccessButtonLabel
      membershipLandingPageNoAccessMembershipAction
      commerceCardShowActionButton
      commerceCardNoAccessButtonLabel
      commerceCardNoAccessAction
      commerceCardWithAccessButtonLabel
      commerceCardWithAccessAction
      commerceLandingPageWithAccessButtonLabel
      commerceLandingPageNoAccessButtonLabel
      commerceLandingPageNoAccessAction
      primaryMembershipID
      membershipOfferPageID
      noAccessImage
      learningBoardGroupNames
      stylesheet
      tokens
      supportedLocales
      defaultCheckoutConfirmationMessage
      courseCardShowImage
      courseCardShowTitle
      courseCardShowInstructor
      courseCardShowDesc
      courseCardShowInfoBar
      courseCardShowActionButton
      courseCardShowLessonCount
      showCertification
      orderConfirmationEmailID
      newCustomerMembershipID
      showLearningBoard
      showUserNameInLearningBoard
      trackDeskTenantId
      cloudfrontDistributionID
      cloudfrontDistributionDomain
      deployedAt
      deployStatus
      googleAnalyticsTagID
      programLandingWithAccessCourseAction
      footerScripts
      repositoryOriginAccessIdentityID
      clientAIAnswerLength
      clientAIFeedbackButtons
      clientAIPromptPlaceholder
      clientAISuggestedPrompts
      clientAIPersistentPrompts
      clientAIPromptTemplate
      clientAIStartingMessage
      clientAIInlineReferences
      clientAISuggestRefinements
      clientAIAdditionalInstructions
      clientAIConfig
      learningBoardConfig
      addToCartEnabled
      productCardConfig
      aiSearchConfig
      clientAIBaseUrl
      showQuizResultsTab
      status
      purgeStatus
      purgeSteps
      purgeError
      __typename
    }
    accessGroups
    enableDiscussionGroups
    enableAI
    defaultRoles
    enableMeetings
    enableHubs
    enableGeo
    clientAILanguageModel
    contentGenerationModel
    clientAIStatus
    crawlConfigs
    internalIpRanges
    usePostHnswFilter
    exportFullConversations
    syncConfigs
    searchGuidance
    status
    deletedAt
    deletedBy
    purgeScheduledAt
    purgeStatus
    purgeSteps
    purgeError
    clonedFromEnv
    clonedAt
    Users {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const createPayment = /* GraphQL */ `mutation CreatePayment(
  $input: CreatePaymentInput!
  $condition: ModelPaymentConditionInput
) {
  createPayment(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    membershipID
    referenceID
    sessionID
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updatePayment = /* GraphQL */ `mutation UpdatePayment(
  $input: UpdatePaymentInput!
  $condition: ModelPaymentConditionInput
) {
  updatePayment(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    membershipID
    referenceID
    sessionID
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deletePayment = /* GraphQL */ `mutation DeletePayment(
  $input: DeletePaymentInput!
  $condition: ModelPaymentConditionInput
) {
  deletePayment(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    membershipID
    referenceID
    sessionID
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createPortal = /* GraphQL */ `mutation CreatePortal(
  $input: CreatePortalInput!
  $condition: ModelPortalConditionInput
) {
  createPortal(input: $input, condition: $condition) {
    id
    organizationID
    defaultLibraryID
    libraries
    libraryShares
    createdAt
    updatedAt
    name
    active
    publicName
    publicDomain
    sslDomain
    description
    type
    allowSearch
    enableInstructors
    requireSignature
    defaultInstructorImage {
      id
      organizationID
      createdAt
      updatedAt
      externalID
      repositoryID
      name
      key
      description
      type
      tags
      mimeType
      derivativeStatus
      transcribeStatus
      status
      access
      dominantColor
      length
      transcript
      scormManifest
      useHls
      hlsGenerated
      __typename
    }
    logoImage
    faviconImage
    ogImage
    categories
    pageDefaults
    pageRules
    componentConfigs
    termsOfService
    cardShowPrice
    publicCardShowActionButton
    publicCardButtonLabel
    publicCardAction
    publicLandingPageButtonLabel
    membershipCardShowActionButton
    membershipCardWithAccessButtonLabel
    membershipCardWithAccessAction
    membershipCardNoAccessButtonLabel
    membershipCardNoAccessAction
    membershipLandingPageWithAccessButtonLabel
    membershipLandingPageNoAccessButtonLabel
    membershipLandingPageNoAccessMembershipAction
    commerceCardShowActionButton
    commerceCardNoAccessButtonLabel
    commerceCardNoAccessAction
    commerceCardWithAccessButtonLabel
    commerceCardWithAccessAction
    commerceLandingPageWithAccessButtonLabel
    commerceLandingPageNoAccessButtonLabel
    commerceLandingPageNoAccessAction
    primaryMembershipID
    membershipOfferPageID
    noAccessImage
    learningBoardGroupNames
    stylesheet
    tokens
    supportedLocales
    defaultCheckoutConfirmationMessage
    courseCardShowImage
    courseCardShowTitle
    courseCardShowInstructor
    courseCardShowDesc
    courseCardShowInfoBar
    courseCardShowActionButton
    courseCardShowLessonCount
    showCertification
    orderConfirmationEmailID
    newCustomerMembershipID
    showLearningBoard
    showUserNameInLearningBoard
    trackDeskTenantId
    cloudfrontDistributionID
    cloudfrontDistributionDomain
    deployedAt
    deployStatus
    googleAnalyticsTagID
    programLandingWithAccessCourseAction
    footerScripts
    repositoryOriginAccessIdentityID
    clientAIAnswerLength
    clientAIFeedbackButtons
    clientAIPromptPlaceholder
    clientAISuggestedPrompts
    clientAIPersistentPrompts
    clientAIPromptTemplate
    clientAIStartingMessage
    clientAIInlineReferences
    clientAISuggestRefinements
    clientAIAdditionalInstructions
    clientAIConfig
    learningBoardConfig
    addToCartEnabled
    productCardConfig
    aiSearchConfig
    clientAIBaseUrl
    showQuizResultsTab
    status
    purgeStatus
    purgeSteps
    purgeError
    __typename
  }
}
`;
export const updatePortal = /* GraphQL */ `mutation UpdatePortal(
  $input: UpdatePortalInput!
  $condition: ModelPortalConditionInput
) {
  updatePortal(input: $input, condition: $condition) {
    id
    organizationID
    defaultLibraryID
    libraries
    libraryShares
    createdAt
    updatedAt
    name
    active
    publicName
    publicDomain
    sslDomain
    description
    type
    allowSearch
    enableInstructors
    requireSignature
    defaultInstructorImage {
      id
      organizationID
      createdAt
      updatedAt
      externalID
      repositoryID
      name
      key
      description
      type
      tags
      mimeType
      derivativeStatus
      transcribeStatus
      status
      access
      dominantColor
      length
      transcript
      scormManifest
      useHls
      hlsGenerated
      __typename
    }
    logoImage
    faviconImage
    ogImage
    categories
    pageDefaults
    pageRules
    componentConfigs
    termsOfService
    cardShowPrice
    publicCardShowActionButton
    publicCardButtonLabel
    publicCardAction
    publicLandingPageButtonLabel
    membershipCardShowActionButton
    membershipCardWithAccessButtonLabel
    membershipCardWithAccessAction
    membershipCardNoAccessButtonLabel
    membershipCardNoAccessAction
    membershipLandingPageWithAccessButtonLabel
    membershipLandingPageNoAccessButtonLabel
    membershipLandingPageNoAccessMembershipAction
    commerceCardShowActionButton
    commerceCardNoAccessButtonLabel
    commerceCardNoAccessAction
    commerceCardWithAccessButtonLabel
    commerceCardWithAccessAction
    commerceLandingPageWithAccessButtonLabel
    commerceLandingPageNoAccessButtonLabel
    commerceLandingPageNoAccessAction
    primaryMembershipID
    membershipOfferPageID
    noAccessImage
    learningBoardGroupNames
    stylesheet
    tokens
    supportedLocales
    defaultCheckoutConfirmationMessage
    courseCardShowImage
    courseCardShowTitle
    courseCardShowInstructor
    courseCardShowDesc
    courseCardShowInfoBar
    courseCardShowActionButton
    courseCardShowLessonCount
    showCertification
    orderConfirmationEmailID
    newCustomerMembershipID
    showLearningBoard
    showUserNameInLearningBoard
    trackDeskTenantId
    cloudfrontDistributionID
    cloudfrontDistributionDomain
    deployedAt
    deployStatus
    googleAnalyticsTagID
    programLandingWithAccessCourseAction
    footerScripts
    repositoryOriginAccessIdentityID
    clientAIAnswerLength
    clientAIFeedbackButtons
    clientAIPromptPlaceholder
    clientAISuggestedPrompts
    clientAIPersistentPrompts
    clientAIPromptTemplate
    clientAIStartingMessage
    clientAIInlineReferences
    clientAISuggestRefinements
    clientAIAdditionalInstructions
    clientAIConfig
    learningBoardConfig
    addToCartEnabled
    productCardConfig
    aiSearchConfig
    clientAIBaseUrl
    showQuizResultsTab
    status
    purgeStatus
    purgeSteps
    purgeError
    __typename
  }
}
`;
export const deletePortal = /* GraphQL */ `mutation DeletePortal(
  $input: DeletePortalInput!
  $condition: ModelPortalConditionInput
) {
  deletePortal(input: $input, condition: $condition) {
    id
    organizationID
    defaultLibraryID
    libraries
    libraryShares
    createdAt
    updatedAt
    name
    active
    publicName
    publicDomain
    sslDomain
    description
    type
    allowSearch
    enableInstructors
    requireSignature
    defaultInstructorImage {
      id
      organizationID
      createdAt
      updatedAt
      externalID
      repositoryID
      name
      key
      description
      type
      tags
      mimeType
      derivativeStatus
      transcribeStatus
      status
      access
      dominantColor
      length
      transcript
      scormManifest
      useHls
      hlsGenerated
      __typename
    }
    logoImage
    faviconImage
    ogImage
    categories
    pageDefaults
    pageRules
    componentConfigs
    termsOfService
    cardShowPrice
    publicCardShowActionButton
    publicCardButtonLabel
    publicCardAction
    publicLandingPageButtonLabel
    membershipCardShowActionButton
    membershipCardWithAccessButtonLabel
    membershipCardWithAccessAction
    membershipCardNoAccessButtonLabel
    membershipCardNoAccessAction
    membershipLandingPageWithAccessButtonLabel
    membershipLandingPageNoAccessButtonLabel
    membershipLandingPageNoAccessMembershipAction
    commerceCardShowActionButton
    commerceCardNoAccessButtonLabel
    commerceCardNoAccessAction
    commerceCardWithAccessButtonLabel
    commerceCardWithAccessAction
    commerceLandingPageWithAccessButtonLabel
    commerceLandingPageNoAccessButtonLabel
    commerceLandingPageNoAccessAction
    primaryMembershipID
    membershipOfferPageID
    noAccessImage
    learningBoardGroupNames
    stylesheet
    tokens
    supportedLocales
    defaultCheckoutConfirmationMessage
    courseCardShowImage
    courseCardShowTitle
    courseCardShowInstructor
    courseCardShowDesc
    courseCardShowInfoBar
    courseCardShowActionButton
    courseCardShowLessonCount
    showCertification
    orderConfirmationEmailID
    newCustomerMembershipID
    showLearningBoard
    showUserNameInLearningBoard
    trackDeskTenantId
    cloudfrontDistributionID
    cloudfrontDistributionDomain
    deployedAt
    deployStatus
    googleAnalyticsTagID
    programLandingWithAccessCourseAction
    footerScripts
    repositoryOriginAccessIdentityID
    clientAIAnswerLength
    clientAIFeedbackButtons
    clientAIPromptPlaceholder
    clientAISuggestedPrompts
    clientAIPersistentPrompts
    clientAIPromptTemplate
    clientAIStartingMessage
    clientAIInlineReferences
    clientAISuggestRefinements
    clientAIAdditionalInstructions
    clientAIConfig
    learningBoardConfig
    addToCartEnabled
    productCardConfig
    aiSearchConfig
    clientAIBaseUrl
    showQuizResultsTab
    status
    purgeStatus
    purgeSteps
    purgeError
    __typename
  }
}
`;
export const createProgram = /* GraphQL */ `mutation CreateProgram(
  $input: CreateProgramInput!
  $condition: ModelProgramConditionInput
) {
  createProgram(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    libraries
    createdAt
    updatedAt
    externalID
    name
    headline
    description
    objectives
    tags
    keywords
    level
    length
    sharePassword
    audience
    searchable
    gated
    requiredSkills
    startDate
    expiryDate
    confirmationMessage
    welcomeMessage
    congratulatoryMessage
    lessons
    enrollmentCount
    price
    sellPrice
    instructors
    reviews
    faqs
    currency
    discountPercent
    companyName
    certification
    active
    ctaUrl
    ctaLabel
    ctaNewWindow
    sections
    lessonCount
    courseCount
    programImage
    searchInstructors
    accessGroups
    excludeFromAllCourses
    courseItems
    microcastItems
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    ogImage
    __typename
  }
}
`;
export const updateProgram = /* GraphQL */ `mutation UpdateProgram(
  $input: UpdateProgramInput!
  $condition: ModelProgramConditionInput
) {
  updateProgram(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    libraries
    createdAt
    updatedAt
    externalID
    name
    headline
    description
    objectives
    tags
    keywords
    level
    length
    sharePassword
    audience
    searchable
    gated
    requiredSkills
    startDate
    expiryDate
    confirmationMessage
    welcomeMessage
    congratulatoryMessage
    lessons
    enrollmentCount
    price
    sellPrice
    instructors
    reviews
    faqs
    currency
    discountPercent
    companyName
    certification
    active
    ctaUrl
    ctaLabel
    ctaNewWindow
    sections
    lessonCount
    courseCount
    programImage
    searchInstructors
    accessGroups
    excludeFromAllCourses
    courseItems
    microcastItems
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    ogImage
    __typename
  }
}
`;
export const deleteProgram = /* GraphQL */ `mutation DeleteProgram(
  $input: DeleteProgramInput!
  $condition: ModelProgramConditionInput
) {
  deleteProgram(input: $input, condition: $condition) {
    id
    organizationID
    slug
    manualSlug
    libraries
    createdAt
    updatedAt
    externalID
    name
    headline
    description
    objectives
    tags
    keywords
    level
    length
    sharePassword
    audience
    searchable
    gated
    requiredSkills
    startDate
    expiryDate
    confirmationMessage
    welcomeMessage
    congratulatoryMessage
    lessons
    enrollmentCount
    price
    sellPrice
    instructors
    reviews
    faqs
    currency
    discountPercent
    companyName
    certification
    active
    ctaUrl
    ctaLabel
    ctaNewWindow
    sections
    lessonCount
    courseCount
    programImage
    searchInstructors
    accessGroups
    excludeFromAllCourses
    courseItems
    microcastItems
    richText1
    richText2
    richText3
    richText4
    richText5
    richText6
    richText7
    richText8
    richText9
    richText10
    discussionTopic
    ogImage
    __typename
  }
}
`;
export const createProgramProgress = /* GraphQL */ `mutation CreateProgramProgress(
  $input: CreateProgramProgressInput!
  $condition: ModelProgramProgressConditionInput
) {
  createProgramProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    programID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    sectionProgress
    lessonsCompleted
    quizResults
    notes
    courseItems
    hasCertification
    certificateAwarded
    certificates
    certifications
    completedCertifications
    certificateStatus
    certificateScore
    certificateAwardedAt
    __typename
  }
}
`;
export const updateProgramProgress = /* GraphQL */ `mutation UpdateProgramProgress(
  $input: UpdateProgramProgressInput!
  $condition: ModelProgramProgressConditionInput
) {
  updateProgramProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    programID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    sectionProgress
    lessonsCompleted
    quizResults
    notes
    courseItems
    hasCertification
    certificateAwarded
    certificates
    certifications
    completedCertifications
    certificateStatus
    certificateScore
    certificateAwardedAt
    __typename
  }
}
`;
export const deleteProgramProgress = /* GraphQL */ `mutation DeleteProgramProgress(
  $input: DeleteProgramProgressInput!
  $condition: ModelProgramProgressConditionInput
) {
  deleteProgramProgress(input: $input, condition: $condition) {
    id
    organizationID
    customerID
    programID
    createdAt
    updatedAt
    progress
    startedDate
    completeDate
    lastActiveDate
    expiryDate
    sectionProgress
    lessonsCompleted
    quizResults
    notes
    courseItems
    hasCertification
    certificateAwarded
    certificates
    certifications
    completedCertifications
    certificateStatus
    certificateScore
    certificateAwardedAt
    __typename
  }
}
`;
export const createRepository = /* GraphQL */ `mutation CreateRepository(
  $input: CreateRepositoryInput!
  $condition: ModelRepositoryConditionInput
) {
  createRepository(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    bucket
    cdnPath
    status
    cloudfrontDistributionDomain
    cloudfrontDistributionID
    cloudfrontOriginAccessIdentity
    deployedAt
    deployStatus
    signingKeyID
    __typename
  }
}
`;
export const updateRepository = /* GraphQL */ `mutation UpdateRepository(
  $input: UpdateRepositoryInput!
  $condition: ModelRepositoryConditionInput
) {
  updateRepository(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    bucket
    cdnPath
    status
    cloudfrontDistributionDomain
    cloudfrontDistributionID
    cloudfrontOriginAccessIdentity
    deployedAt
    deployStatus
    signingKeyID
    __typename
  }
}
`;
export const deleteRepository = /* GraphQL */ `mutation DeleteRepository(
  $input: DeleteRepositoryInput!
  $condition: ModelRepositoryConditionInput
) {
  deleteRepository(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    bucket
    cdnPath
    status
    cloudfrontDistributionDomain
    cloudfrontDistributionID
    cloudfrontOriginAccessIdentity
    deployedAt
    deployStatus
    signingKeyID
    __typename
  }
}
`;
export const createQuestionnaire = /* GraphQL */ `mutation CreateQuestionnaire(
  $input: CreateQuestionnaireInput!
  $condition: ModelQuestionnaireConditionInput
) {
  createQuestionnaire(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    createdAt
    updatedAt
    startedAt
    completedAt
    name
    email
    welcomeMessage
    completionMessage
    status
    questions
    __typename
  }
}
`;
export const updateQuestionnaire = /* GraphQL */ `mutation UpdateQuestionnaire(
  $input: UpdateQuestionnaireInput!
  $condition: ModelQuestionnaireConditionInput
) {
  updateQuestionnaire(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    createdAt
    updatedAt
    startedAt
    completedAt
    name
    email
    welcomeMessage
    completionMessage
    status
    questions
    __typename
  }
}
`;
export const deleteQuestionnaire = /* GraphQL */ `mutation DeleteQuestionnaire(
  $input: DeleteQuestionnaireInput!
  $condition: ModelQuestionnaireConditionInput
) {
  deleteQuestionnaire(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    createdAt
    updatedAt
    startedAt
    completedAt
    name
    email
    welcomeMessage
    completionMessage
    status
    questions
    __typename
  }
}
`;
export const createQuestion = /* GraphQL */ `mutation CreateQuestion(
  $input: CreateQuestionInput!
  $condition: ModelQuestionConditionInput
) {
  createQuestion(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    type
    availableAnswers
    selectedAnswers
    __typename
  }
}
`;
export const updateQuestion = /* GraphQL */ `mutation UpdateQuestion(
  $input: UpdateQuestionInput!
  $condition: ModelQuestionConditionInput
) {
  updateQuestion(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    type
    availableAnswers
    selectedAnswers
    __typename
  }
}
`;
export const deleteQuestion = /* GraphQL */ `mutation DeleteQuestion(
  $input: DeleteQuestionInput!
  $condition: ModelQuestionConditionInput
) {
  deleteQuestion(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    type
    availableAnswers
    selectedAnswers
    __typename
  }
}
`;
export const createShopifyConfig = /* GraphQL */ `mutation CreateShopifyConfig(
  $input: CreateShopifyConfigInput!
  $condition: ModelShopifyConfigConditionInput
) {
  createShopifyConfig(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    shop
    storefrontDomain
    status
    clientAiKey
    productFeedEnabled
    indexCategories
    ignoreInventory
    ignoreOnlineStoreUrl
    productFeedStatus
    metafieldsConfig
    productTemplate
    titleTemplate
    parentTitleTemplate
    productActiveTemplate
    additionalProductDataCSV
    catalogTaxonomyAssetID
    productDescriptionOptimizationInstructions
    productDescriptionOptimizationMaxWords
    additionalProductDataConfig
    billingPlanType
    billingTier
    targetBillingTier
    merchantApprovedAmount
    customBillingAmount
    billingMessage
    installationDate
    subscriptionStart
    lastPaymentDate
    freePeriodExpiry
    contactName
    contactEmail
    contactPhone
    customizableTag
    __typename
  }
}
`;
export const updateShopifyConfig = /* GraphQL */ `mutation UpdateShopifyConfig(
  $input: UpdateShopifyConfigInput!
  $condition: ModelShopifyConfigConditionInput
) {
  updateShopifyConfig(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    shop
    storefrontDomain
    status
    clientAiKey
    productFeedEnabled
    indexCategories
    ignoreInventory
    ignoreOnlineStoreUrl
    productFeedStatus
    metafieldsConfig
    productTemplate
    titleTemplate
    parentTitleTemplate
    productActiveTemplate
    additionalProductDataCSV
    catalogTaxonomyAssetID
    productDescriptionOptimizationInstructions
    productDescriptionOptimizationMaxWords
    additionalProductDataConfig
    billingPlanType
    billingTier
    targetBillingTier
    merchantApprovedAmount
    customBillingAmount
    billingMessage
    installationDate
    subscriptionStart
    lastPaymentDate
    freePeriodExpiry
    contactName
    contactEmail
    contactPhone
    customizableTag
    __typename
  }
}
`;
export const deleteShopifyConfig = /* GraphQL */ `mutation DeleteShopifyConfig(
  $input: DeleteShopifyConfigInput!
  $condition: ModelShopifyConfigConditionInput
) {
  deleteShopifyConfig(input: $input, condition: $condition) {
    id
    organizationID
    createdAt
    updatedAt
    name
    description
    shop
    storefrontDomain
    status
    clientAiKey
    productFeedEnabled
    indexCategories
    ignoreInventory
    ignoreOnlineStoreUrl
    productFeedStatus
    metafieldsConfig
    productTemplate
    titleTemplate
    parentTitleTemplate
    productActiveTemplate
    additionalProductDataCSV
    catalogTaxonomyAssetID
    productDescriptionOptimizationInstructions
    productDescriptionOptimizationMaxWords
    additionalProductDataConfig
    billingPlanType
    billingTier
    targetBillingTier
    merchantApprovedAmount
    customBillingAmount
    billingMessage
    installationDate
    subscriptionStart
    lastPaymentDate
    freePeriodExpiry
    contactName
    contactEmail
    contactPhone
    customizableTag
    __typename
  }
}
`;
export const createProduct = /* GraphQL */ `mutation CreateProduct(
  $input: CreateProductInput!
  $condition: ModelProductConditionInput
) {
  createProduct(input: $input, condition: $condition) {
    id
    organizationID
    syncConfigID
    handle
    name
    bodyHtml
    vendor
    productType
    imageSrc
    url
    tags
    status
    optionTypes
    productData
    catalogCategorization
    attributes
    productSheet
    externalIDs
    variants
    relatedGuideIds
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateProduct = /* GraphQL */ `mutation UpdateProduct(
  $input: UpdateProductInput!
  $condition: ModelProductConditionInput
) {
  updateProduct(input: $input, condition: $condition) {
    id
    organizationID
    syncConfigID
    handle
    name
    bodyHtml
    vendor
    productType
    imageSrc
    url
    tags
    status
    optionTypes
    productData
    catalogCategorization
    attributes
    productSheet
    externalIDs
    variants
    relatedGuideIds
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteProduct = /* GraphQL */ `mutation DeleteProduct(
  $input: DeleteProductInput!
  $condition: ModelProductConditionInput
) {
  deleteProduct(input: $input, condition: $condition) {
    id
    organizationID
    syncConfigID
    handle
    name
    bodyHtml
    vendor
    productType
    imageSrc
    url
    tags
    status
    optionTypes
    productData
    catalogCategorization
    attributes
    productSheet
    externalIDs
    variants
    relatedGuideIds
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createWebPage = /* GraphQL */ `mutation CreateWebPage(
  $input: CreateWebPageInput!
  $condition: ModelWebPageConditionInput
) {
  createWebPage(input: $input, condition: $condition) {
    id
    organizationID
    crawlID
    url
    name
    description
    pageMarkdown
    screenshotKey
    pageData
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateWebPage = /* GraphQL */ `mutation UpdateWebPage(
  $input: UpdateWebPageInput!
  $condition: ModelWebPageConditionInput
) {
  updateWebPage(input: $input, condition: $condition) {
    id
    organizationID
    crawlID
    url
    name
    description
    pageMarkdown
    screenshotKey
    pageData
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteWebPage = /* GraphQL */ `mutation DeleteWebPage(
  $input: DeleteWebPageInput!
  $condition: ModelWebPageConditionInput
) {
  deleteWebPage(input: $input, condition: $condition) {
    id
    organizationID
    crawlID
    url
    name
    description
    pageMarkdown
    screenshotKey
    pageData
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createCategory = /* GraphQL */ `mutation CreateCategory(
  $input: CreateCategoryInput!
  $condition: ModelCategoryConditionInput
) {
  createCategory(input: $input, condition: $condition) {
    id
    organizationID
    syncConfigID
    handle
    name
    descriptionHtml
    imageUrl
    productCount
    relatedGuideIds
    categoryData
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateCategory = /* GraphQL */ `mutation UpdateCategory(
  $input: UpdateCategoryInput!
  $condition: ModelCategoryConditionInput
) {
  updateCategory(input: $input, condition: $condition) {
    id
    organizationID
    syncConfigID
    handle
    name
    descriptionHtml
    imageUrl
    productCount
    relatedGuideIds
    categoryData
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteCategory = /* GraphQL */ `mutation DeleteCategory(
  $input: DeleteCategoryInput!
  $condition: ModelCategoryConditionInput
) {
  deleteCategory(input: $input, condition: $condition) {
    id
    organizationID
    syncConfigID
    handle
    name
    descriptionHtml
    imageUrl
    productCount
    relatedGuideIds
    categoryData
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createGuideCluster = /* GraphQL */ `mutation CreateGuideCluster(
  $input: CreateGuideClusterInput!
  $condition: ModelGuideClusterConditionInput
) {
  createGuideCluster(input: $input, condition: $condition) {
    id
    organizationID
    recordType
    portalID
    syncConfigID
    name
    description
    strategyTags
    discoverySourceUrl
    externalKey
    coreGuideId
    parentJobId
    refinementRound
    openAiResponseId
    sourceUrl
    strategyLevel
    additionalInstructions
    lastRefinementNotes
    resultJson
    errorMessage
    status
    proposalJobId
    entityType
    changeType
    targetId
    currentJson
    proposedJson
    reason
    sortOrder
    reviewStatus
    sourceSignals
    clusterConfidence
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateGuideCluster = /* GraphQL */ `mutation UpdateGuideCluster(
  $input: UpdateGuideClusterInput!
  $condition: ModelGuideClusterConditionInput
) {
  updateGuideCluster(input: $input, condition: $condition) {
    id
    organizationID
    recordType
    portalID
    syncConfigID
    name
    description
    strategyTags
    discoverySourceUrl
    externalKey
    coreGuideId
    parentJobId
    refinementRound
    openAiResponseId
    sourceUrl
    strategyLevel
    additionalInstructions
    lastRefinementNotes
    resultJson
    errorMessage
    status
    proposalJobId
    entityType
    changeType
    targetId
    currentJson
    proposedJson
    reason
    sortOrder
    reviewStatus
    sourceSignals
    clusterConfidence
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteGuideCluster = /* GraphQL */ `mutation DeleteGuideCluster(
  $input: DeleteGuideClusterInput!
  $condition: ModelGuideClusterConditionInput
) {
  deleteGuideCluster(input: $input, condition: $condition) {
    id
    organizationID
    recordType
    portalID
    syncConfigID
    name
    description
    strategyTags
    discoverySourceUrl
    externalKey
    coreGuideId
    parentJobId
    refinementRound
    openAiResponseId
    sourceUrl
    strategyLevel
    additionalInstructions
    lastRefinementNotes
    resultJson
    errorMessage
    status
    proposalJobId
    entityType
    changeType
    targetId
    currentJson
    proposedJson
    reason
    sortOrder
    reviewStatus
    sourceSignals
    clusterConfidence
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createGuide = /* GraphQL */ `mutation CreateGuide(
  $input: CreateGuideInput!
  $condition: ModelGuideConditionInput
) {
  createGuide(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    syncConfigID
    guideClusterID
    guideType
    role
    targetPrompts
    intentDescription
    title
    slug
    excerpt
    keywords
    relatedGuideIds
    bylineInstructorID
    reviewerInstructorID
    metaTitle
    metaDescription
    guideImageAssetID
    guideImageUrl
    guideImageAltText
    guideImageSource
    guideImagePrompt
    content
    status
    sourceUrl
    topic
    generationStatus
    generationErrorMessage
    generationFailureId
    generationFailurePhase
    publishStatus
    publishGateStatus
    shopifyBlogId
    shopifyBlogHandle
    shopifyArticleId
    shopifyArticleHandle
    shopifyArticleUrl
    shopifyArticleTemplateSuffix
    lastPublishAttemptAt
    lastPublishOperation
    lastPublishErrorMessage
    shopifyUrlSource
    publishVerificationStatus
    lastPublishResponse
    publishedAt
    lastGeneratedAt
    lastPublishedAt
    suggestedProductHandles
    approvalStatus
    approvalNote
    generationSource
    syncStatus
    lastSyncedAt
    createdAt
    updatedAt
    publishedVersionId
    currentDraftVersionId
    currentChangeSetId
    livePublishedAt
    deletedAt
    guideScore
    guideScoreBreakdown
    lastScoredAt
    guideScoreFingerprint
    __typename
  }
}
`;
export const updateGuide = /* GraphQL */ `mutation UpdateGuide(
  $input: UpdateGuideInput!
  $condition: ModelGuideConditionInput
) {
  updateGuide(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    syncConfigID
    guideClusterID
    guideType
    role
    targetPrompts
    intentDescription
    title
    slug
    excerpt
    keywords
    relatedGuideIds
    bylineInstructorID
    reviewerInstructorID
    metaTitle
    metaDescription
    guideImageAssetID
    guideImageUrl
    guideImageAltText
    guideImageSource
    guideImagePrompt
    content
    status
    sourceUrl
    topic
    generationStatus
    generationErrorMessage
    generationFailureId
    generationFailurePhase
    publishStatus
    publishGateStatus
    shopifyBlogId
    shopifyBlogHandle
    shopifyArticleId
    shopifyArticleHandle
    shopifyArticleUrl
    shopifyArticleTemplateSuffix
    lastPublishAttemptAt
    lastPublishOperation
    lastPublishErrorMessage
    shopifyUrlSource
    publishVerificationStatus
    lastPublishResponse
    publishedAt
    lastGeneratedAt
    lastPublishedAt
    suggestedProductHandles
    approvalStatus
    approvalNote
    generationSource
    syncStatus
    lastSyncedAt
    createdAt
    updatedAt
    publishedVersionId
    currentDraftVersionId
    currentChangeSetId
    livePublishedAt
    deletedAt
    guideScore
    guideScoreBreakdown
    lastScoredAt
    guideScoreFingerprint
    __typename
  }
}
`;
export const deleteGuide = /* GraphQL */ `mutation DeleteGuide(
  $input: DeleteGuideInput!
  $condition: ModelGuideConditionInput
) {
  deleteGuide(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    syncConfigID
    guideClusterID
    guideType
    role
    targetPrompts
    intentDescription
    title
    slug
    excerpt
    keywords
    relatedGuideIds
    bylineInstructorID
    reviewerInstructorID
    metaTitle
    metaDescription
    guideImageAssetID
    guideImageUrl
    guideImageAltText
    guideImageSource
    guideImagePrompt
    content
    status
    sourceUrl
    topic
    generationStatus
    generationErrorMessage
    generationFailureId
    generationFailurePhase
    publishStatus
    publishGateStatus
    shopifyBlogId
    shopifyBlogHandle
    shopifyArticleId
    shopifyArticleHandle
    shopifyArticleUrl
    shopifyArticleTemplateSuffix
    lastPublishAttemptAt
    lastPublishOperation
    lastPublishErrorMessage
    shopifyUrlSource
    publishVerificationStatus
    lastPublishResponse
    publishedAt
    lastGeneratedAt
    lastPublishedAt
    suggestedProductHandles
    approvalStatus
    approvalNote
    generationSource
    syncStatus
    lastSyncedAt
    createdAt
    updatedAt
    publishedVersionId
    currentDraftVersionId
    currentChangeSetId
    livePublishedAt
    deletedAt
    guideScore
    guideScoreBreakdown
    lastScoredAt
    guideScoreFingerprint
    __typename
  }
}
`;
export const createCourseAlertConfig = /* GraphQL */ `mutation CreateCourseAlertConfig(
  $input: CreateCourseAlertConfigInput!
  $condition: ModelCourseAlertConfigConditionInput
) {
  createCourseAlertConfig(input: $input, condition: $condition) {
    organizationID
    courseID
    alertsEmail
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateCourseAlertConfig = /* GraphQL */ `mutation UpdateCourseAlertConfig(
  $input: UpdateCourseAlertConfigInput!
  $condition: ModelCourseAlertConfigConditionInput
) {
  updateCourseAlertConfig(input: $input, condition: $condition) {
    organizationID
    courseID
    alertsEmail
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteCourseAlertConfig = /* GraphQL */ `mutation DeleteCourseAlertConfig(
  $input: DeleteCourseAlertConfigInput!
  $condition: ModelCourseAlertConfigConditionInput
) {
  deleteCourseAlertConfig(input: $input, condition: $condition) {
    organizationID
    courseID
    alertsEmail
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createGeoConfiguration = /* GraphQL */ `mutation CreateGeoConfiguration(
  $input: CreateGeoConfigurationInput!
  $condition: ModelGeoConfigurationConditionInput
) {
  createGeoConfiguration(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    marketCountry
    marketLocale
    marketCurrency
    activeChangeSetId
    siteUrl
    brandDescription
    audience
    voiceTone
    avoidGuidance
    vertical
    competitorUrls
    brandName
    brandAliases
    competitors
    defaultStrategyLevel
    defaultPlanScope
    planAdditionalInstructions
    topicsPromptOverride
    contentPromptOverride
    guideLengthPreference
    guideStructureNotes
    imageStyleNotes
    imageComplianceNotes
    imageGenerationPromptOverride
    defaultBlogHandle
    defaultArticleTemplateSuffix
    publishWorkflow
    publishAdapter
    allowedSourceDomains
    ugcDomains
    mustNotContainPatterns
    onboardingComplete
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateGeoConfiguration = /* GraphQL */ `mutation UpdateGeoConfiguration(
  $input: UpdateGeoConfigurationInput!
  $condition: ModelGeoConfigurationConditionInput
) {
  updateGeoConfiguration(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    marketCountry
    marketLocale
    marketCurrency
    activeChangeSetId
    siteUrl
    brandDescription
    audience
    voiceTone
    avoidGuidance
    vertical
    competitorUrls
    brandName
    brandAliases
    competitors
    defaultStrategyLevel
    defaultPlanScope
    planAdditionalInstructions
    topicsPromptOverride
    contentPromptOverride
    guideLengthPreference
    guideStructureNotes
    imageStyleNotes
    imageComplianceNotes
    imageGenerationPromptOverride
    defaultBlogHandle
    defaultArticleTemplateSuffix
    publishWorkflow
    publishAdapter
    allowedSourceDomains
    ugcDomains
    mustNotContainPatterns
    onboardingComplete
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteGeoConfiguration = /* GraphQL */ `mutation DeleteGeoConfiguration(
  $input: DeleteGeoConfigurationInput!
  $condition: ModelGeoConfigurationConditionInput
) {
  deleteGeoConfiguration(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    marketCountry
    marketLocale
    marketCurrency
    activeChangeSetId
    siteUrl
    brandDescription
    audience
    voiceTone
    avoidGuidance
    vertical
    competitorUrls
    brandName
    brandAliases
    competitors
    defaultStrategyLevel
    defaultPlanScope
    planAdditionalInstructions
    topicsPromptOverride
    contentPromptOverride
    guideLengthPreference
    guideStructureNotes
    imageStyleNotes
    imageComplianceNotes
    imageGenerationPromptOverride
    defaultBlogHandle
    defaultArticleTemplateSuffix
    publishWorkflow
    publishAdapter
    allowedSourceDomains
    ugcDomains
    mustNotContainPatterns
    onboardingComplete
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createTrackedPrompt = /* GraphQL */ `mutation CreateTrackedPrompt(
  $input: CreateTrackedPromptInput!
  $condition: ModelTrackedPromptConditionInput
) {
  createTrackedPrompt(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    text
    clusterID
    clusterProposed
    status
    hasGuide
    lastScannedAt
    latestVisibilityScore
    latestBrandMentioned
    latestEngineBreakdown
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateTrackedPrompt = /* GraphQL */ `mutation UpdateTrackedPrompt(
  $input: UpdateTrackedPromptInput!
  $condition: ModelTrackedPromptConditionInput
) {
  updateTrackedPrompt(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    text
    clusterID
    clusterProposed
    status
    hasGuide
    lastScannedAt
    latestVisibilityScore
    latestBrandMentioned
    latestEngineBreakdown
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteTrackedPrompt = /* GraphQL */ `mutation DeleteTrackedPrompt(
  $input: DeleteTrackedPromptInput!
  $condition: ModelTrackedPromptConditionInput
) {
  deleteTrackedPrompt(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    text
    clusterID
    clusterProposed
    status
    hasGuide
    lastScannedAt
    latestVisibilityScore
    latestBrandMentioned
    latestEngineBreakdown
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createContentSource = /* GraphQL */ `mutation CreateContentSource(
  $input: CreateContentSourceInput!
  $condition: ModelContentSourceConditionInput
) {
  createContentSource(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    sourceType
    sourceSubtype
    ingestMethod
    status
    recordCount
    processedAt
    metadata
    taskId
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateContentSource = /* GraphQL */ `mutation UpdateContentSource(
  $input: UpdateContentSourceInput!
  $condition: ModelContentSourceConditionInput
) {
  updateContentSource(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    sourceType
    sourceSubtype
    ingestMethod
    status
    recordCount
    processedAt
    metadata
    taskId
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteContentSource = /* GraphQL */ `mutation DeleteContentSource(
  $input: DeleteContentSourceInput!
  $condition: ModelContentSourceConditionInput
) {
  deleteContentSource(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    sourceType
    sourceSubtype
    ingestMethod
    status
    recordCount
    processedAt
    metadata
    taskId
    errorMessage
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createExtractedTopic = /* GraphQL */ `mutation CreateExtractedTopic(
  $input: CreateExtractedTopicInput!
  $condition: ModelExtractedTopicConditionInput
) {
  createExtractedTopic(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    contentSourceId
    topic
    rawText
    frequency
    confidence
    status
    assignedClusterID
    metadata
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateExtractedTopic = /* GraphQL */ `mutation UpdateExtractedTopic(
  $input: UpdateExtractedTopicInput!
  $condition: ModelExtractedTopicConditionInput
) {
  updateExtractedTopic(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    contentSourceId
    topic
    rawText
    frequency
    confidence
    status
    assignedClusterID
    metadata
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteExtractedTopic = /* GraphQL */ `mutation DeleteExtractedTopic(
  $input: DeleteExtractedTopicInput!
  $condition: ModelExtractedTopicConditionInput
) {
  deleteExtractedTopic(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    contentSourceId
    topic
    rawText
    frequency
    confidence
    status
    assignedClusterID
    metadata
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createGeoScoreSnapshot = /* GraphQL */ `mutation CreateGeoScoreSnapshot(
  $input: CreateGeoScoreSnapshotInput!
  $condition: ModelGeoScoreSnapshotConditionInput
) {
  createGeoScoreSnapshot(input: $input, condition: $condition) {
    id
    organizationID
    seriesKey
    scope
    entityId
    date
    score
    subscores
    source
    capturedAt
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateGeoScoreSnapshot = /* GraphQL */ `mutation UpdateGeoScoreSnapshot(
  $input: UpdateGeoScoreSnapshotInput!
  $condition: ModelGeoScoreSnapshotConditionInput
) {
  updateGeoScoreSnapshot(input: $input, condition: $condition) {
    id
    organizationID
    seriesKey
    scope
    entityId
    date
    score
    subscores
    source
    capturedAt
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteGeoScoreSnapshot = /* GraphQL */ `mutation DeleteGeoScoreSnapshot(
  $input: DeleteGeoScoreSnapshotInput!
  $condition: ModelGeoScoreSnapshotConditionInput
) {
  deleteGeoScoreSnapshot(input: $input, condition: $condition) {
    id
    organizationID
    seriesKey
    scope
    entityId
    date
    score
    subscores
    source
    capturedAt
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createVisibilityScan = /* GraphQL */ `mutation CreateVisibilityScan(
  $input: CreateVisibilityScanInput!
  $condition: ModelVisibilityScanConditionInput
) {
  createVisibilityScan(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    marketCountry
    localizationMethod
    trackedPromptID
    promptText
    engine
    scannedAt
    rawResponse
    brandMentioned
    brandMentionedRegex
    brandMentionCount
    brandPosition
    brandContext
    competitorMentions
    citations
    visibilityScore
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateVisibilityScan = /* GraphQL */ `mutation UpdateVisibilityScan(
  $input: UpdateVisibilityScanInput!
  $condition: ModelVisibilityScanConditionInput
) {
  updateVisibilityScan(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    marketCountry
    localizationMethod
    trackedPromptID
    promptText
    engine
    scannedAt
    rawResponse
    brandMentioned
    brandMentionedRegex
    brandMentionCount
    brandPosition
    brandContext
    competitorMentions
    citations
    visibilityScore
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteVisibilityScan = /* GraphQL */ `mutation DeleteVisibilityScan(
  $input: DeleteVisibilityScanInput!
  $condition: ModelVisibilityScanConditionInput
) {
  deleteVisibilityScan(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    marketCountry
    localizationMethod
    trackedPromptID
    promptText
    engine
    scannedAt
    rawResponse
    brandMentioned
    brandMentionedRegex
    brandMentionCount
    brandPosition
    brandContext
    competitorMentions
    citations
    visibilityScore
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createAdminEvent = /* GraphQL */ `mutation CreateAdminEvent(
  $input: CreateAdminEventInput!
  $condition: ModelAdminEventConditionInput
) {
  createAdminEvent(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    eventType
    source
    message
    iconHint
    taskId
    relatedEntityType
    relatedEntityId
    ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateAdminEvent = /* GraphQL */ `mutation UpdateAdminEvent(
  $input: UpdateAdminEventInput!
  $condition: ModelAdminEventConditionInput
) {
  updateAdminEvent(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    eventType
    source
    message
    iconHint
    taskId
    relatedEntityType
    relatedEntityId
    ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteAdminEvent = /* GraphQL */ `mutation DeleteAdminEvent(
  $input: DeleteAdminEventInput!
  $condition: ModelAdminEventConditionInput
) {
  deleteAdminEvent(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    eventType
    source
    message
    iconHint
    taskId
    relatedEntityType
    relatedEntityId
    ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    name
    biography
    profileImage
    email
    background
    headline
    title
    enableAdminAgent
    Organizations {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    name
    biography
    profileImage
    email
    background
    headline
    title
    enableAdminAgent
    Organizations {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    name
    biography
    profileImage
    email
    background
    headline
    title
    enableAdminAgent
    Organizations {
      nextToken
      __typename
    }
    __typename
  }
}
`;
export const createUserOrganization = /* GraphQL */ `mutation CreateUserOrganization(
  $input: CreateUserOrganizationInput!
  $condition: ModelUserOrganizationConditionInput
) {
  createUserOrganization(input: $input, condition: $condition) {
    id
    userID
    organizationID
    name
    superUser
    roles
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateUserOrganization = /* GraphQL */ `mutation UpdateUserOrganization(
  $input: UpdateUserOrganizationInput!
  $condition: ModelUserOrganizationConditionInput
) {
  updateUserOrganization(input: $input, condition: $condition) {
    id
    userID
    organizationID
    name
    superUser
    roles
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteUserOrganization = /* GraphQL */ `mutation DeleteUserOrganization(
  $input: DeleteUserOrganizationInput!
  $condition: ModelUserOrganizationConditionInput
) {
  deleteUserOrganization(input: $input, condition: $condition) {
    id
    userID
    organizationID
    name
    superUser
    roles
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createPortalKicker = /* GraphQL */ `mutation CreatePortalKicker(
  $input: CreatePortalKickerInput!
  $condition: ModelPortalKickerConditionInput
) {
  createPortalKicker(input: $input, condition: $condition) {
    id
    organizationID
    name
    assetID
    link
    openInNewTab
    createdAt
    updatedAt
    endAt
    tags
    text1
    text2
    text3
    text4
    text5
    richText1
    richText2
    richText3
    richText4
    richText5
    __typename
  }
}
`;
export const updatePortalKicker = /* GraphQL */ `mutation UpdatePortalKicker(
  $input: UpdatePortalKickerInput!
  $condition: ModelPortalKickerConditionInput
) {
  updatePortalKicker(input: $input, condition: $condition) {
    id
    organizationID
    name
    assetID
    link
    openInNewTab
    createdAt
    updatedAt
    endAt
    tags
    text1
    text2
    text3
    text4
    text5
    richText1
    richText2
    richText3
    richText4
    richText5
    __typename
  }
}
`;
export const deletePortalKicker = /* GraphQL */ `mutation DeletePortalKicker(
  $input: DeletePortalKickerInput!
  $condition: ModelPortalKickerConditionInput
) {
  deletePortalKicker(input: $input, condition: $condition) {
    id
    organizationID
    name
    assetID
    link
    openInNewTab
    createdAt
    updatedAt
    endAt
    tags
    text1
    text2
    text3
    text4
    text5
    richText1
    richText2
    richText3
    richText4
    richText5
    __typename
  }
}
`;
export const createPageVersion = /* GraphQL */ `mutation CreatePageVersion(
  $input: CreatePageVersionInput!
  $condition: ModelPageVersionConditionInput
) {
  createPageVersion(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    guideId
    versionNumber
    snapshot
    snapshotS3Key
    checksum
    authorType
    authorId
    sourceType
    taskId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updatePageVersion = /* GraphQL */ `mutation UpdatePageVersion(
  $input: UpdatePageVersionInput!
  $condition: ModelPageVersionConditionInput
) {
  updatePageVersion(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    guideId
    versionNumber
    snapshot
    snapshotS3Key
    checksum
    authorType
    authorId
    sourceType
    taskId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deletePageVersion = /* GraphQL */ `mutation DeletePageVersion(
  $input: DeletePageVersionInput!
  $condition: ModelPageVersionConditionInput
) {
  deletePageVersion(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    guideId
    versionNumber
    snapshot
    snapshotS3Key
    checksum
    authorType
    authorId
    sourceType
    taskId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createCycle = /* GraphQL */ `mutation CreateCycle(
  $input: CreateCycleInput!
  $condition: ModelCycleConditionInput
) {
  createCycle(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    cycleNumber
    name
    description
    status
    phase
    startedAt
    closedAt
    plannedApprovalAt
    plannedShipAt
    maintenanceRanAt
    baselineSnapshot
    measureSnapshot
    activeChangeSetId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateCycle = /* GraphQL */ `mutation UpdateCycle(
  $input: UpdateCycleInput!
  $condition: ModelCycleConditionInput
) {
  updateCycle(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    cycleNumber
    name
    description
    status
    phase
    startedAt
    closedAt
    plannedApprovalAt
    plannedShipAt
    maintenanceRanAt
    baselineSnapshot
    measureSnapshot
    activeChangeSetId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteCycle = /* GraphQL */ `mutation DeleteCycle(
  $input: DeleteCycleInput!
  $condition: ModelCycleConditionInput
) {
  deleteCycle(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    cycleNumber
    name
    description
    status
    phase
    startedAt
    closedAt
    plannedApprovalAt
    plannedShipAt
    maintenanceRanAt
    baselineSnapshot
    measureSnapshot
    activeChangeSetId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createRecommendation = /* GraphQL */ `mutation CreateRecommendation(
  $input: CreateRecommendationInput!
  $condition: ModelRecommendationConditionInput
) {
  createRecommendation(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    cycleId
    kind
    status
    text
    payload
    source
    dedupeKey
    order
    committedEntityId
    appliedChangeSetItemId
    originCycleId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateRecommendation = /* GraphQL */ `mutation UpdateRecommendation(
  $input: UpdateRecommendationInput!
  $condition: ModelRecommendationConditionInput
) {
  updateRecommendation(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    cycleId
    kind
    status
    text
    payload
    source
    dedupeKey
    order
    committedEntityId
    appliedChangeSetItemId
    originCycleId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteRecommendation = /* GraphQL */ `mutation DeleteRecommendation(
  $input: DeleteRecommendationInput!
  $condition: ModelRecommendationConditionInput
) {
  deleteRecommendation(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    cycleId
    kind
    status
    text
    payload
    source
    dedupeKey
    order
    committedEntityId
    appliedChangeSetItemId
    originCycleId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createChangeSet = /* GraphQL */ `mutation CreateChangeSet(
  $input: CreateChangeSetInput!
  $condition: ModelChangeSetConditionInput
) {
  createChangeSet(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    title
    status
    itemCount
    createdBy
    submittedForApprovalAt
    submittedForApprovalBy
    approvedAt
    approvedBy
    rejectedAt
    rejectedBy
    rejectionNote
    publishedAt
    publishedBy
    kind
    previousChangeSetId
    supersededByChangeSetId
    lockedAt
    cycleId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateChangeSet = /* GraphQL */ `mutation UpdateChangeSet(
  $input: UpdateChangeSetInput!
  $condition: ModelChangeSetConditionInput
) {
  updateChangeSet(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    title
    status
    itemCount
    createdBy
    submittedForApprovalAt
    submittedForApprovalBy
    approvedAt
    approvedBy
    rejectedAt
    rejectedBy
    rejectionNote
    publishedAt
    publishedBy
    kind
    previousChangeSetId
    supersededByChangeSetId
    lockedAt
    cycleId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteChangeSet = /* GraphQL */ `mutation DeleteChangeSet(
  $input: DeleteChangeSetInput!
  $condition: ModelChangeSetConditionInput
) {
  deleteChangeSet(input: $input, condition: $condition) {
    id
    organizationID
    portalID
    title
    status
    itemCount
    createdBy
    submittedForApprovalAt
    submittedForApprovalBy
    approvedAt
    approvedBy
    rejectedAt
    rejectedBy
    rejectionNote
    publishedAt
    publishedBy
    kind
    previousChangeSetId
    supersededByChangeSetId
    lockedAt
    cycleId
    createdAt
    updatedAt
    __typename
  }
}
`;
export const createChangeSetItem = /* GraphQL */ `mutation CreateChangeSetItem(
  $input: CreateChangeSetItemInput!
  $condition: ModelChangeSetItemConditionInput
) {
  createChangeSetItem(input: $input, condition: $condition) {
    id
    changeSetId
    organizationID
    portalID
    entityType
    entityId
    newVersionId
    newVersionNumber
    previousVersionId
    previousVersionNumber
    fromVersionId
    fromVersionNumber
    operation
    diffSummary
    itemStatus
    changeKind
    publishAttemptAt
    createdAt
    updatedAt
    __typename
  }
}
`;
export const updateChangeSetItem = /* GraphQL */ `mutation UpdateChangeSetItem(
  $input: UpdateChangeSetItemInput!
  $condition: ModelChangeSetItemConditionInput
) {
  updateChangeSetItem(input: $input, condition: $condition) {
    id
    changeSetId
    organizationID
    portalID
    entityType
    entityId
    newVersionId
    newVersionNumber
    previousVersionId
    previousVersionNumber
    fromVersionId
    fromVersionNumber
    operation
    diffSummary
    itemStatus
    changeKind
    publishAttemptAt
    createdAt
    updatedAt
    __typename
  }
}
`;
export const deleteChangeSetItem = /* GraphQL */ `mutation DeleteChangeSetItem(
  $input: DeleteChangeSetItemInput!
  $condition: ModelChangeSetItemConditionInput
) {
  deleteChangeSetItem(input: $input, condition: $condition) {
    id
    changeSetId
    organizationID
    portalID
    entityType
    entityId
    newVersionId
    newVersionNumber
    previousVersionId
    previousVersionNumber
    fromVersionId
    fromVersionNumber
    operation
    diffSummary
    itemStatus
    changeKind
    publishAttemptAt
    createdAt
    updatedAt
    __typename
  }
}
`;
//# sourceMappingURL=mutations.js.map